import _slicedToArray from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _toConsumableArray from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
var _ae, _ne;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var It = Object.defineProperty,
  vt = Object.defineProperties;
var Et = Object.getOwnPropertyDescriptors;
var _e = Object.getOwnPropertySymbols;
var bt = Object.prototype.hasOwnProperty,
  At = Object.prototype.propertyIsEnumerable;
var Ue = function Ue(s, e, t) {
    return e in s ? It(s, e, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : s[e] = t;
  },
  w = function w(s, e) {
    for (var t in e || (e = {})) bt.call(e, t) && Ue(s, t, e[t]);
    if (_e) {
      var _iterator = _createForOfIteratorHelper(_e(e)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          At.call(e, t) && Ue(s, t, e[t]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return s;
  },
  Q = function Q(s, e) {
    return vt(s, Et(e));
  };
var Ct = function Ct(s, e) {
  return function () {
    return e || s((e = {
      exports: {}
    }).exports, e), e.exports;
  };
};
var c = function c(s, e, t) {
  return new Promise(function (i, o) {
    var r = function r(M) {
        try {
          n(t.next(M));
        } catch (R) {
          o(R);
        }
      },
      a = function a(M) {
        try {
          n(t.throw(M));
        } catch (R) {
          o(R);
        }
      },
      n = function n(M) {
        return M.done ? i(M.value) : Promise.resolve(M.value).then(r, a);
      };
    n((t = t.apply(s, e)).next());
  });
};
var Dt = Ct(function (Jn, Bs) {
  Bs.exports = {
    version: "0.8.4",
    license: "MIT",
    main: "dist/index.cjs.js",
    module: "dist/index.js",
    typings: "dist/index.d.ts",
    files: ["dist", "src"],
    engines: {
      node: ">=12"
    },
    exports: {
      ".": {
        require: "./dist/index.cjs.js",
        import: "./dist/index.js",
        default: "./dist/index.js"
      }
    },
    scripts: {
      prestart: "rm -rf dist && yarn types:build",
      start: 'concurrently "yarn dev" "yarn types"',
      dev: "node ../../scripts/dev",
      "build:only": "node ../../scripts/build",
      build: "yarn build:only && yarn types:build",
      types: "tsc -w",
      "types:build": "tsc -p tsconfig.json",
      format: "prettier --write src/**/*.ts",
      test: "jest --maxWorkers=1",
      "test:watch": "jest --watch",
      "test:coverage": "jest --coverage",
      lint: "eslint -c ../../.eslintrc .",
      "lint:fix": "yarn lint --fix",
      prepare: "yarn build",
      size: "size-limit",
      analyze: "size-limit --why",
      docs: "rm -rf ./docs && typedoc && rm -f ./docs/README.md && mkdir ./docs/home &&mv ./docs/modules.md ./docs/home/content.md && node ../../scripts/docs-store && npx prettier --write './docs/**/*'"
    },
    name: "@100mslive/hms-video-store",
    author: "100ms",
    sideEffects: !1,
    dependencies: {
      "@100mslive/hms-video": "0.7.4",
      eventemitter2: "^6.4.7",
      immer: "^9.0.6",
      reselect: "4.0.0",
      zustand: "3.5.7"
    },
    devDependencies: {
      "ts-node": "^10.4.0",
      tslib: "^2.2.0"
    },
    description: "This is an addon to the core sdk provided by 100ms. It abstracts away the intricacies of data management and provides a flux based reactive data store where data flows in only one direction.",
    repository: {
      type: "git",
      url: "git+https://github.com/100mslive/hms-video-store.git"
    },
    keywords: ["video", "webrtc", "conferencing", "100ms"],
    bugs: {
      url: "https://github.com/100mslive/hms-video-store/issues"
    },
    homepage: "https://github.com/100mslive/hms-video-store#readme",
    gitHead: "36f8d865f05deffecd7a64fb7f3aba1070561584"
  };
});
import qs from "immer";
import js from "zustand/shallow";
import Fs from "zustand/vanilla";
import { HMSSdk as $s, isBrowser as Gs } from "@100mslive/hms-video";
import { EventEmitter2 as as } from "eventemitter2";
var f;
(function (n) {
  n.Disconnected = "Disconnected", n.Preview = "Preview", n.Connecting = "Connecting", n.Connected = "Connected", n.Reconnecting = "Reconnecting", n.Disconnecting = "Disconnecting", n.Failed = "Failed";
})(f || (f = {}));
var ie = function ie() {
    return {
      room: {
        id: "",
        isConnected: !1,
        name: "",
        peers: [],
        localPeer: "",
        roomState: f.Disconnected,
        recording: {
          browser: {
            running: !1
          },
          server: {
            running: !1
          },
          hls: {
            running: !1
          }
        },
        rtmp: {
          running: !1
        },
        hls: {
          running: !1,
          variants: []
        },
        sessionId: ""
      },
      peers: {},
      tracks: {},
      playlist: {
        audio: {
          list: {},
          selection: {
            id: "",
            hasPrevious: !1,
            hasNext: !1
          },
          progress: 0,
          volume: 0,
          currentTime: 0,
          playbackRate: 1
        },
        video: {
          list: {},
          selection: {
            id: "",
            hasPrevious: !1,
            hasNext: !1
          },
          progress: 0,
          volume: 0,
          currentTime: 0,
          playbackRate: 1
        }
      },
      messages: {
        byID: {},
        allIDs: []
      },
      speakers: {},
      connectionQualities: {},
      settings: {
        audioInputDeviceId: "",
        audioOutputDeviceId: "",
        videoInputDeviceId: ""
      },
      devices: {
        audioInput: [],
        audioOutput: [],
        videoInput: []
      },
      roles: {},
      roleChangeRequests: [],
      errors: []
    };
  },
  oe = function oe() {
    return {
      peerStats: {},
      remoteTrackStats: {},
      localTrackStats: {},
      localPeer: {
        id: ""
      }
    };
  };
var Ke;
(function (e) {
  e.CHAT = "chat";
})(Ke || (Ke = {}));
var P;
(function (t) {
  t.INFO = "info", t.ERROR = "error";
})(P || (P = {}));
var m;
(function (S) {
  S.PEER_JOINED = "PEER_JOINED", S.PEER_LEFT = "PEER_LEFT", S.PEER_LIST = "PEER_LIST", S.NEW_MESSAGE = "NEW_MESSAGE", S.ERROR = "ERROR", S.RECONNECTING = "RECONNECTING", S.RECONNECTED = "RECONNECTED", S.TRACK_ADDED = "TRACK_ADDED", S.TRACK_REMOVED = "TRACK_REMOVED", S.TRACK_MUTED = "TRACK_MUTED", S.TRACK_UNMUTED = "TRACK_UNMUTED", S.TRACK_DEGRADED = "TRACK_DEGRADED", S.TRACK_RESTORED = "TRACK_RESTORED", S.TRACK_DESCRIPTION_CHANGED = "TRACK_DESCRIPTION_CHANGED", S.ROLE_UPDATED = "ROLE_UPDATED", S.CHANGE_TRACK_STATE_REQUEST = "CHANGE_TRACK_STATE_REQUEST", S.CHANGE_MULTI_TRACK_STATE_REQUEST = "CHANGE_MULTI_TRACK_STATE_REQUEST", S.ROOM_ENDED = "ROOM_ENDED", S.REMOVED_FROM_ROOM = "REMOVED_FROM_ROOM", S.DEVICE_CHANGE_UPDATE = "DEVICE_CHANGE_UPDATE", S.PLAYLIST_TRACK_ENDED = "PLAYLIST_TRACK_ENDED", S.NAME_UPDATED = "NAME_UPDATED", S.METADATA_UPDATED = "METADATA_UPDATED";
})(m || (m = {}));
var p;
(function (t) {
  t.audio = "audio", t.video = "video";
})(p || (p = {}));
import { DeviceType as Nt, HMSAudioPluginType as xt, HMSException as ui, HMSLogLevel as y, HMSPeerUpdate as K, HMSRoomUpdate as Ai, HMSSimulcastLayer as Lt, HMSTrackUpdate as A, HMSVideoPluginCanvasContextType as Ot, HMSVideoPluginType as wt, parsedUserAgent as _t, simulcastMapping as re } from "@100mslive/hms-video";
var ae = (_ae = {}, _defineProperty(_ae, K.PEER_JOINED, m.PEER_JOINED), _defineProperty(_ae, K.PEER_LEFT, m.PEER_LEFT), _defineProperty(_ae, K.ROLE_UPDATED, m.ROLE_UPDATED), _defineProperty(_ae, K.NAME_UPDATED, m.NAME_UPDATED), _defineProperty(_ae, K.METADATA_UPDATED, m.METADATA_UPDATED), _ae),
  ne = (_ne = {}, _defineProperty(_ne, A.TRACK_ADDED, m.TRACK_ADDED), _defineProperty(_ne, A.TRACK_REMOVED, m.TRACK_REMOVED), _defineProperty(_ne, A.TRACK_MUTED, m.TRACK_MUTED), _defineProperty(_ne, A.TRACK_UNMUTED, m.TRACK_UNMUTED), _defineProperty(_ne, A.TRACK_DEGRADED, m.TRACK_DEGRADED), _defineProperty(_ne, A.TRACK_RESTORED, m.TRACK_RESTORED), _defineProperty(_ne, A.TRACK_DESCRIPTION_CHANGED, m.TRACK_DESCRIPTION_CHANGED), _ne);
import { createSelector as l } from "reselect";
function $(s, e) {
  var t, i;
  if (e) {
    var _iterator2 = _createForOfIteratorHelper(e.auxiliaryTracks),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var o = _step2.value;
        var r = s[o];
        Ut(r) && (i = Y(r) ? r : i, t = z(r) ? r : t);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return {
    video: t,
    audio: i
  };
}
function Y(s) {
  return s && s.type === "audio";
}
function z(s) {
  return s && s.type === "video";
}
function Ut(s) {
  return s && s.source === "screen";
}
function ce(s) {
  return s && s.source === "audioplaylist";
}
function X(s) {
  return s && s.source === "videoplaylist";
}
function Ve(s) {
  return s ? Boolean(s == null ? void 0 : s.degraded) : !1;
}
function J(s, e) {
  return e && s.tracks[e] ? s.tracks[e].enabled : !1;
}
function Be(s, e) {
  return e && s.tracks[e] ? s.tracks[e].displayEnabled : !1;
}
function Z(s) {
  var o;
  var e = !1,
    t = !1,
    i = !1;
  return ((o = s == null ? void 0 : s.publishParams) == null ? void 0 : o.allowed) && (e = s.publishParams.allowed.includes("video"), t = s.publishParams.allowed.includes("audio"), i = s.publishParams.allowed.includes("screen")), {
    video: e,
    audio: t,
    screen: i
  };
}
var D = function D(s) {
    return s.room;
  },
  Kt = function Kt(s) {
    return s.errors;
  },
  oo = l(Kt, function (s) {
    return s.length === 0 ? null : s.at(-1);
  }),
  ro = l(D, function (s) {
    return s.id;
  }),
  v = function v(s) {
    return s.peers;
  },
  qe = function qe(s) {
    return s.messages.byID;
  },
  je = function je(s) {
    return s.messages.allIDs;
  },
  h = function h(s) {
    return s.tracks;
  },
  Fe = function Fe(s) {
    return s.settings;
  },
  fe = function fe(s) {
    return s.appData;
  },
  ao = function ao(s) {
    return s.devices;
  },
  Vt = function Vt(s) {
    return s.speakers;
  },
  no = function no(s) {
    return s.connectionQualities;
  },
  he = l([D], function (s) {
    return s && s.isConnected;
  }),
  co = l([he, D], function (s, e) {
    return s ? e.peerCount !== void 0 ? e.peerCount || 1 : e.peers.length : Math.max(e.peerCount !== void 0 ? e.peerCount : e.peers.length - 1, 0);
  }),
  G = l([D, v], function (s, e) {
    return s.peers.map(function (t) {
      return e[t];
    });
  }),
  Bt = l(h, function (s) {
    return Object.values(s);
  }),
  E = l(D, v, function (s, e) {
    return e[s.localPeer];
  }),
  W = l(D, function (s) {
    return s.localPeer;
  }),
  So = l(E, function (s) {
    return s == null ? void 0 : s.name;
  }),
  lo = l(E, function (s) {
    return s == null ? void 0 : s.roleName;
  }),
  C = l(E, function (s) {
    return s == null ? void 0 : s.audioTrack;
  }),
  N = l(E, function (s) {
    return s == null ? void 0 : s.videoTrack;
  }),
  qt = l(E, function (s) {
    return s == null ? void 0 : s.auxiliaryTracks;
  }),
  $e = l([C, N, qt], function (s, e, t) {
    var i = t ? _toConsumableArray(t) : [];
    return s && i.unshift(s), e && i.unshift(e), i;
  }),
  uo = l(G, function (s) {
    return s.filter(function (e) {
      return !e.isLocal;
    });
  }),
  Mo = l(v, Vt, function (s, e) {
    var t = Object.entries(e).sort(function (i, o) {
      var n, M;
      var r = ((n = i[1]) == null ? void 0 : n.audioLevel) || 0;
      return (((M = o[1]) == null ? void 0 : M.audioLevel) || 0) > r ? 1 : -1;
    });
    if (t.length > 0 && t[0][1].audioLevel && t[0][1].audioLevel > 0) {
      var i = t[0][1].peerID;
      if (i in s) return s[i];
    }
    return null;
  }),
  po = function po(s) {
    var e = E(s);
    return J(s, e == null ? void 0 : e.audioTrack);
  },
  ge = function ge(s) {
    var e = E(s);
    return J(s, e == null ? void 0 : e.videoTrack);
  },
  Ge = function Ge(s) {
    var e = E(s);
    return Be(s, e == null ? void 0 : e.videoTrack);
  },
  ye = l(E, h, function (s, e) {
    var _$ = $(e, s),
      t = _$.video,
      i = _$.audio;
    return !!(t || i);
  }),
  jt = l(v, h, function (s, e) {
    var t;
    for (var i in s) {
      var o = s[i],
        _$2 = $(e, o),
        r = _$2.video,
        a = _$2.audio;
      if (r) return o;
      a && !t && (t = o);
    }
    return t;
  }),
  To = l(jt, function (s) {
    return !!s;
  }),
  mo = l(v, h, function (s, e) {
    for (var t in s) {
      var i = s[t],
        _$3 = $(e, i),
        o = _$3.audio,
        r = _$3.video;
      if (!r && !!o) return i;
    }
  }),
  Ho = l(v, h, function (s, e) {
    var t = [],
      i = [];
    for (var o in s) {
      var r = s[o],
        _$4 = $(e, r),
        a = _$4.video,
        n = _$4.audio;
      a ? t.push(r) : n && i.push(r);
    }
    return t.concat(i);
  }),
  fo = l(v, h, function (s, e) {
    for (var t in e) {
      var i = e[t];
      if (X(i) && z(i) && i.peerId) return s[i.peerId];
    }
  }),
  ho = l(v, h, function (s, e) {
    for (var t in e) {
      var i = e[t];
      if (ce(i) && i.peerId) return s[i.peerId];
    }
  }),
  go = l(Bt, function (s) {
    return s.filter(Ve);
  }),
  We = l(je, function (s) {
    return s.length;
  }),
  yo = l(qe, function (s) {
    return Object.values(s).filter(function (e) {
      return !e.read;
    }).length;
  }),
  Se = l(je, qe, function (s, e) {
    var t = [];
    return s.forEach(function (i) {
      t.push(e[i]);
    }), t;
  }),
  b = l([D], function (s) {
    return s && s.roomState;
  }),
  ko = l(b, function (s) {
    return s === f.Preview;
  }),
  Po = l(D, function (s) {
    return s.roomState !== f.Disconnected;
  }),
  _ = function _(s) {
    return s.roles;
  },
  Ro = l([_], function (s) {
    return Object.keys(s);
  }),
  le = l([E, _], function (s, e) {
    return (s == null ? void 0 : s.roleName) ? e[s.roleName] : null;
  }),
  Ft = function Ft(s) {
    var e;
    return (e = s.preview) == null ? void 0 : e.asRole;
  },
  Qe = l([Ft, _], function (s, e) {
    return s ? e[s] : null;
  }),
  Do = l([le], function (s) {
    var e;
    return ((e = s == null ? void 0 : s.subscribeParams) == null ? void 0 : e.subscribeToRoles) ? s.subscribeParams.subscribeToRoles.length > 0 : !1;
  }),
  Je = l(le, function (s) {
    return s == null ? void 0 : s.permissions;
  }),
  Io = l(D, function (s) {
    return s.recording;
  }),
  vo = l(D, function (s) {
    return s.rtmp;
  }),
  Eo = l(D, function (s) {
    return s.hls;
  }),
  bo = l(D, function (s) {
    return s.sessionId;
  }),
  Ao = l(D, function (s) {
    return s.startedAt;
  }),
  Co = function Co(s) {
    return s.sessionMetadata;
  };
import { createSelector as Ye } from "reselect";
var ze = function ze() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return function (e) {
      return e.playlist[s].list;
    };
  },
  ke = function ke() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return function (e) {
      return e.playlist[s].selection;
    };
  },
  Xe = function Xe() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return function (e) {
      return e.playlist[s].progress;
    };
  },
  Ze = function Ze() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return function (e) {
      return e.playlist[s].currentTime;
    };
  },
  et = function et() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return function (e) {
      return e.playlist[s].playbackRate;
    };
  },
  tt = function tt() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return function (e) {
      return e.playlist[s].volume;
    };
  },
  st = function st() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return Ye(ze(s), function (e) {
      return Object.values(e);
    });
  },
  it = function it() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : p.audio;
    return Ye(ze(s), ke(s), function (e, t) {
      if (!!t.id) return e[t.id];
    });
  },
  ot = {
    selection: ke(p.audio),
    progress: Xe(p.audio),
    currentTime: Ze(p.audio),
    playbackRate: et(p.audio),
    volume: tt(p.audio),
    list: st(p.audio),
    selectedItem: it(p.audio)
  },
  rt = {
    selection: ke(p.video),
    progress: Xe(p.video),
    currentTime: Ze(p.video),
    playbackRate: et(p.video),
    volume: tt(p.video),
    list: st(p.video),
    selectedItem: it(p.video)
  };
import { createSelector as H } from "reselect";
function d(s) {
  return function (e) {
    return function (t) {
      return s(t, e);
    };
  };
}
var ee = "HMS-Store:",
  u = /*#__PURE__*/function () {
    function u() {
      _classCallCheck(this, u);
    }
    _createClass(u, null, [{
      key: "v",
      value: function v(e) {
        for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          t[_key - 1] = arguments[_key];
        }
        this.log.apply(this, [y.VERBOSE, e].concat(t));
      }
    }, {
      key: "d",
      value: function d() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        this.log.apply(this, [y.DEBUG].concat(e));
      }
    }, {
      key: "i",
      value: function i() {
        for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          e[_key3] = arguments[_key3];
        }
        this.log.apply(this, [y.INFO].concat(e));
      }
    }, {
      key: "w",
      value: function w() {
        for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          e[_key4] = arguments[_key4];
        }
        this.log.apply(this, [y.WARN].concat(e));
      }
    }, {
      key: "e",
      value: function e() {
        for (var _len5 = arguments.length, _e2 = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          _e2[_key5] = arguments[_key5];
        }
        this.log.apply(this, [y.ERROR].concat(_e2));
      }
    }, {
      key: "time",
      value: function time(e) {
        this.log(y.TIME, "[HMSPerformanceTiming]", e);
      }
    }, {
      key: "timeEnd",
      value: function timeEnd(e) {
        this.log(y.TIMEEND, "[HMSPerformanceTiming]", e, e);
      }
    }, {
      key: "cleanUp",
      value: function cleanUp() {
        performance.clearMarks(), performance.clearMeasures();
      }
    }, {
      key: "log",
      value: function log(e) {
        for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
          t[_key6 - 1] = arguments[_key6];
        }
        if (!(this.level.valueOf() > e.valueOf())) switch (e) {
          case y.VERBOSE:
            {
              var _console;
              (_console = console).log.apply(_console, [ee].concat(t));
              break;
            }
          case y.DEBUG:
            {
              var _console2;
              (_console2 = console).debug.apply(_console2, [ee].concat(t));
              break;
            }
          case y.INFO:
            {
              var _console3;
              (_console3 = console).info.apply(_console3, [ee].concat(t));
              break;
            }
          case y.WARN:
            {
              var _console4;
              (_console4 = console).warn.apply(_console4, [ee].concat(t));
              break;
            }
          case y.ERROR:
            {
              var _console5;
              (_console5 = console).error.apply(_console5, [ee].concat(t));
              break;
            }
          case y.TIME:
            {
              performance.mark(t[1]);
              break;
            }
          case y.TIMEEND:
            {
              var i = t[0],
                o = t[1];
              try {
                var r = performance.measure(o, o);
                this.log(y.DEBUG, i, o, r == null ? void 0 : r.duration), performance.clearMarks(o), performance.clearMeasures(o);
              } catch (r) {
                this.log(y.DEBUG, i, o, r);
              }
              break;
            }
        }
      }
    }]);
    return u;
  }();
u.level = y.VERBOSE;
var Pe = function Pe(s, e) {
    return e;
  },
  te = function te(s, e) {
    return e;
  },
  at = function at(s, e) {
    return e;
  },
  $t = function $t(s, e) {
    return e;
  },
  I = H([v, Pe], function (s, e) {
    return e ? s[e] : null;
  }),
  Re = H([h, te], function (s, e) {
    return e ? s[e] : null;
  }),
  Gt = H([h, te], function (s, e) {
    if (!e) return null;
    var t = s[e];
    return (t == null ? void 0 : t.type) === "video" ? t : null;
  }),
  Wt = H([h, te], function (s, e) {
    if (!e) return null;
    var t = s[e];
    return (t == null ? void 0 : t.type) === "audio" ? t : null;
  }),
  Qt = H([h, te], function (s, e) {
    if (!e) return null;
    var t = s[e];
    return (t == null ? void 0 : t.type) === "audio" && (t == null ? void 0 : t.source) === "screen" ? t : null;
  }),
  Jt = H([h, te], function (s, e) {
    if (!e) return null;
    var t = s[e];
    return (t == null ? void 0 : t.type) === "video" && (t == null ? void 0 : t.source) === "screen" ? t : null;
  }),
  x = d(I),
  Go = d(H([fe, $t], function (s, e) {
    if (!!s) return e ? s[e] : s;
  })),
  Wo = function Wo() {
    for (var _len7 = arguments.length, s = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      s[_key7] = arguments[_key7];
    }
    return H([fe], function (e) {
      if (!!e) {
        if (s && s.length > 0) {
          var t = e;
          for (var _i = 0, _s2 = s; _i < _s2.length; _i++) {
            var i = _s2[_i];
            if (!i) return t;
            t = t == null ? void 0 : t[i];
          }
          return t;
        }
        return e;
      }
    });
  },
  Qo = d(H(I, function (s) {
    return s == null ? void 0 : s.name;
  })),
  de = d(Re),
  nt = d(Gt),
  Jo = d(Wt),
  Yo = d(Qt),
  zo = d(Jt),
  Yt = d(function (s, e) {
    var t = I(s, e);
    if (t && t.videoTrack && t.videoTrack !== "") return s.tracks[t.videoTrack];
  }),
  zt = d(function (s, e) {
    var t = I(s, e);
    if (t && t.audioTrack && t.audioTrack !== "") return s.tracks[t.audioTrack];
  }),
  Xo = Yt,
  Zo = d(function (s, e) {
    var t = I(s, e);
    return (t == null ? void 0 : t.auxiliaryTracks.map(function (i) {
      return s.tracks[i];
    })) || [];
  }),
  ct = function ct(s, e) {
    return e ? s.speakers[e] : null;
  },
  er = d(H(ct, function (s) {
    return (s == null ? void 0 : s.audioLevel) || 0;
  })),
  Xt = function Xt(s, e) {
    var t = zt(e)(s);
    return ct(s, t == null ? void 0 : t.id);
  },
  tr = d(H(Xt, function (s) {
    return (s == null ? void 0 : s.audioLevel) || 0;
  })),
  sr = d(function (s, e) {
    if (e) return s.connectionQualities[e];
  }),
  ir = d(function (s, e) {
    var t = I(s, e);
    if (t) {
      var i = t == null ? void 0 : t.auxiliaryTracks.find(function (o) {
        return Y(s.tracks[o]);
      });
      return i ? s.tracks[i] : void 0;
    }
  }),
  or = d(H(h, I, function (s, e) {
    var t = e == null ? void 0 : e.auxiliaryTracks.find(function (i) {
      var o = s[i];
      return X(o) && z(o);
    });
    return t ? s[t] : void 0;
  })),
  rr = d(H(h, I, function (s, e) {
    var t = e == null ? void 0 : e.auxiliaryTracks.find(function (i) {
      var o = s[i];
      return X(o) && Y(o);
    });
    return t ? s[t] : void 0;
  })),
  ar = d(H(h, I, function (s, e) {
    var t = e == null ? void 0 : e.auxiliaryTracks.find(function (i) {
      var o = s[i];
      return ce(o) && Y(o);
    });
    return t ? s[t] : void 0;
  })),
  St = d(H(h, I, function (s, e) {
    return $(s, e);
  })),
  nr = function nr(s) {
    return H(St(s), function (e) {
      return e.video;
    });
  },
  lt = function lt(s) {
    return H(St(s), function (e) {
      return e.audio;
    });
  },
  cr = d(function (s, e) {
    var t = I(s, e);
    return J(s, t == null ? void 0 : t.audioTrack);
  }),
  Sr = d(function (s, e) {
    var t = I(s, e);
    return J(s, t == null ? void 0 : t.videoTrack);
  }),
  dt = d(function (s, e) {
    if (e && s.tracks[e]) return s.tracks[e].volume === 0;
  }),
  lr = d(function (s, e) {
    var t = I(s, e);
    return dt(t == null ? void 0 : t.audioTrack)(s);
  }),
  dr = d(function (s, e) {
    var t = lt(e)(s);
    return dt(t == null ? void 0 : t.id)(s);
  }),
  ut = d(function (s, e) {
    var t = Re(s, e);
    if (t) {
      if (t.type !== "audio") {
        u.w("Please pass audio track here");
        return;
      }
      return t.volume;
    }
  }),
  ur = d(function (s, e) {
    var t = I(s, e);
    return ut(t == null ? void 0 : t.audioTrack)(s);
  }),
  Mr = d(function (s, e) {
    var t = lt(e)(s);
    return ut(t == null ? void 0 : t.id)(s);
  }),
  pr = d(function (s, e) {
    var t = Re(s, e);
    if (t) {
      if (t.type !== "video") {
        u.w("Please pass video track here");
        return;
      }
      return t.layer;
    }
  }),
  Mt = H([Se, W, Pe], function (s, e, t) {
    if (!!t) return s.filter(function (i) {
      var o;
      return !i.recipientPeer && !((o = i.recipientRoles) == null ? void 0 : o.length) || i.sender && ![e, t].includes(i.sender) ? !1 : [e, t].includes(i.recipientPeer);
    });
  }),
  pt = H([Se, at], function (s, e) {
    if (!!e) return s.filter(function (t) {
      var i, o;
      return ((i = t.recipientRoles) == null ? void 0 : i.length) ? (o = t.recipientRoles) == null ? void 0 : o.includes(e) : !1;
    });
  }),
  Zt = H(Se, function (s) {
    return s.filter(function (e) {
      var t;
      return !e.recipientPeer && !((t = e.recipientRoles) == null ? void 0 : t.length);
    });
  }),
  es = H([pt, at], function (s) {
    return s ? s.filter(function (e) {
      return !e.read;
    }).length : 0;
  }),
  ts = H([Mt, Pe], function (s) {
    return s ? s.filter(function (e) {
      return !e.read;
    }).length : 0;
  }),
  Tr = H(Zt, function (s) {
    return s.filter(function (e) {
      return !e.read;
    }).length;
  }),
  mr = d(Mt),
  Hr = d(pt),
  fr = d(es),
  hr = d(ts),
  gr = function gr(s) {
    return H([G], function (e) {
      return e.filter(function (t) {
        return t.roleName === s;
      });
    });
  },
  yr = function yr(s) {
    return H([G], function (e) {
      return e.filter(function (t) {
        return t.roleName ? s.includes(t.roleName) : !1;
      });
    });
  },
  kr = function kr(s) {
    return H(x(s), function (e) {
      try {
        return (e == null ? void 0 : e.metadata) && e.metadata !== "" ? JSON.parse(e.metadata) : {};
      } catch (t) {
        return console.error("cannot parse peer metadata", t), {};
      }
    });
  },
  Pr = function Pr(s) {
    return H(x(s), function (e) {
      return e == null ? void 0 : e.name;
    });
  };
import { createSelector as ue } from "reselect";
var Er = ue([v, h], function (s, e) {
    return Object.values(s).map(function (i) {
      var o;
      return {
        peer: i,
        isAudioEnabled: i.audioTrack ? (o = e[i.audioTrack]) == null ? void 0 : o.enabled : !1
      };
    });
  }),
  ss = function ss(s) {
    return s.roleChangeRequests[0] || null;
  },
  br = ue([ss, v, _], function (s, e, t) {
    return s ? {
      requestedBy: s.requestedBy ? e[s.requestedBy] : void 0,
      role: t[s.roleName],
      token: s.token
    } : null;
  }),
  Ar = ue([le], function (s) {
    return Z(s);
  }),
  Cr = ue([Qe], function (s) {
    return Z(s);
  });
import { createSelector as V } from "reselect";
var is = function is(s) {
    return V([_], function (e) {
      return e[s];
    });
  },
  wr = function wr(s) {
    return V(is(s), function (e) {
      return Z(e);
    });
  },
  os = V([N, h], function (s, e) {
    var t = null;
    return s && (t = e[s]), (t == null ? void 0 : t.plugins) || [];
  }),
  rs = V([C, h], function (s, e) {
    var t = null;
    return s && (t = e[s]), (t == null ? void 0 : t.plugins) || [];
  }),
  _r = function _r(s) {
    return V([os], function (e) {
      return e.includes(s);
    });
  },
  Ur = function Ur(s) {
    return V([rs], function (e) {
      return e.includes(s);
    });
  },
  Kr = function Kr(s) {
    return V(G, function (e) {
      return e.find(s);
    });
  },
  Vr = function Vr(s) {
    return V(G, function (e) {
      return e.filter(s);
    });
  },
  Br = function Br(s) {
    return V(D, function (e) {
      return e.joinedAt && Date.now() - e.joinedAt.getTime() <= s;
    });
  };
var De = "hmsNotification",
  Ie = /*#__PURE__*/function () {
    function Ie(e) {
      var _this = this;
      _classCallCheck(this, Ie);
      this.id = 0;
      this.onNotification = function (e, t) {
        var i = function i(o) {
          if (t) {
            var r;
            if (Array.isArray(t) ? r = t.includes(o.type) : r = t === o.type, !r) return;
          }
          e(o);
        };
        return _this.eventEmitter.addListener(De, i), function () {
          _this.eventEmitter.removeListener(De, i);
        };
      };
      this.store = e, this.eventEmitter = new as({
        maxListeners: Object.keys(m).length
      });
    }
    _createClass(Ie, [{
      key: "sendPlaylistTrackEnded",
      value: function sendPlaylistTrackEnded(e) {
        var t = this.createNotification(m.PLAYLIST_TRACK_ENDED, e, P.INFO);
        this.emitEvent(t);
      }
    }, {
      key: "sendDeviceChange",
      value: function sendDeviceChange(e) {
        var i;
        var t = this.createNotification(m.DEVICE_CHANGE_UPDATE, e, e.error ? P.ERROR : P.INFO, "Selected ".concat(e.type, " device - ").concat((i = e.selection) == null ? void 0 : i.label));
        this.emitEvent(t);
      }
    }, {
      key: "sendLeaveRoom",
      value: function sendLeaveRoom(e) {
        var o;
        var t = (o = e.requestedBy) == null ? void 0 : o.name,
          i = this.createNotification(e.roomEnded || !t ? m.ROOM_ENDED : m.REMOVED_FROM_ROOM, e, P.INFO, "".concat(e.roomEnded ? "Room ended" : "Removed from room", " ").concat(t ? "by ".concat(t) : ""));
        this.emitEvent(i);
      }
    }, {
      key: "sendPeerList",
      value: function sendPeerList(e) {
        var t = this.createNotification(m.PEER_LIST, e, P.INFO);
        this.emitEvent(t);
      }
    }, {
      key: "sendPeerUpdate",
      value: function sendPeerUpdate(e, t) {
        var i = this.store.getState(x(t == null ? void 0 : t.id)) || t,
          o = ae[e];
        if (o) {
          var r = this.createNotification(o, i, P.INFO);
          this.emitEvent(r);
        }
      }
    }, {
      key: "sendTrackUpdate",
      value: function sendTrackUpdate(e, t) {
        var i = this.store.getState(de(t)),
          o = ne[e];
        if (o) {
          var r = this.createNotification(o, i, P.INFO);
          this.emitEvent(r);
        }
      }
    }, {
      key: "sendMessageReceived",
      value: function sendMessageReceived(e) {
        var t = this.createNotification(m.NEW_MESSAGE, e, P.INFO);
        this.emitEvent(t);
      }
    }, {
      key: "sendError",
      value: function sendError(e) {
        var t = this.createNotification(m.ERROR, e, P.ERROR);
        this.emitEvent(t);
      }
    }, {
      key: "sendReconnecting",
      value: function sendReconnecting(e) {
        var t = this.createNotification(m.RECONNECTING, e, P.ERROR);
        this.emitEvent(t);
      }
    }, {
      key: "sendReconnected",
      value: function sendReconnected() {
        var e = this.createNotification(m.RECONNECTED, null, P.INFO);
        this.emitEvent(e);
      }
    }, {
      key: "sendChangeTrackStateRequest",
      value: function sendChangeTrackStateRequest(e) {
        var t = this.createNotification(m.CHANGE_TRACK_STATE_REQUEST, e, P.INFO);
        this.emitEvent(t);
      }
    }, {
      key: "sendChangeMultiTrackStateRequest",
      value: function sendChangeMultiTrackStateRequest(e) {
        var t = this.createNotification(m.CHANGE_MULTI_TRACK_STATE_REQUEST, e, P.INFO);
        this.emitEvent(t);
      }
    }, {
      key: "emitEvent",
      value: function emitEvent(e) {
        this.eventEmitter.emit(De, e);
      }
    }, {
      key: "createNotification",
      value: function createNotification(e, t, i) {
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
        return this.id++, {
          id: this.id,
          type: e,
          message: o,
          data: t,
          severity: i
        };
      }
    }]);
    return Ie;
  }();
import { HMSAudioTrack as ds, HMSException as us, HMSRemoteVideoTrack as Ms, HMSSimulcastLayer as gt } from "@100mslive/hms-video";
import { HMSRemoteAudioTrack as ns, HMSRemoteVideoTrack as cs } from "@100mslive/hms-video";
function Tt(s) {
  return s instanceof ns || s instanceof cs;
}
var mt = function mt(s, e) {
    var t = Me(Object.keys(s), Object.keys(e));
    var _iterator3 = _createForOfIteratorHelper(t),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var i = _step3.value;
        var o = s[i],
          r = e[i];
        Ee(o, r) ? (U(o.auxiliaryTracks, r.auxiliaryTracks) && (r.auxiliaryTracks = o.auxiliaryTracks), Object.assign(o, r)) : be(o, r) ? delete s[i] : Ae(o, r) && (s[i] = r);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  },
  Ht = function Ht(s, e) {
    var t = Me(Object.keys(s), Object.keys(e));
    var _iterator4 = _createForOfIteratorHelper(t),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var i = _step4.value;
        var o = s[i],
          r = e[i];
        Ee(o, r) ? (Ss(o, r), Object.assign(o, r)) : be(o, r) ? delete s[i] : Ae(o, r) && (s[i] = r);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  },
  ve = function ve(s, e) {
    var t = Me(Object.keys(s), Object.keys(e));
    var _iterator5 = _createForOfIteratorHelper(t),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var i = _step5.value;
        var o = s[i],
          r = e[i];
        Ee(o, r) ? Object.assign(o, r) : be(o, r) ? delete s[i] : Ae(o, r) && (s[i] = r);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  },
  ft = function ft(s, e, t) {
    var i = t.reduce(function (r, a) {
        return r[a.firstTrackId] = Object.values(e[a.getTrackIDBeingSent()] || {}).sort(function (n, M) {
          return !n.rid || !M.rid ? 0 : n.rid < M.rid ? -1 : 1;
        }), r;
      }, {}),
      o = Me(Object.keys(s), Object.keys(i));
    var _iterator6 = _createForOfIteratorHelper(o),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var r = _step6.value;
        if (!i[r]) {
          delete s[r];
          continue;
        }
        s[r] = i[r];
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  },
  Ss = function Ss(s, e) {
    s.plugins && U(s.plugins, e.plugins) && (e.plugins = s.plugins), s.type === "video" && s.layerDefinitions && U(s.layerDefinitions, e.layerDefinitions) && (e.layerDefinitions = s.layerDefinitions);
  },
  Ee = function Ee(s, e) {
    return s && e;
  },
  be = function be(s, e) {
    return s && !e;
  },
  Ae = function Ae(s, e) {
    return !s && e;
  },
  U = function U(s, e) {
    if (s === e || s.length === 0 && (e == null ? void 0 : e.length) === 0) return !0;
    if (!s || !e || s.length !== e.length) return !1;
    for (var t = 0; t < s.length; t++) if (s[t] !== e[t]) return !1;
    return !0;
  },
  Me = function Me(s, e) {
    var t = new Set();
    var _iterator7 = _createForOfIteratorHelper(s),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var i = _step7.value;
        t.add(i);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    var _iterator8 = _createForOfIteratorHelper(e),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _i2 = _step8.value;
        t.add(_i2);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    return Array.from(t);
  };
import { HMSLocalAudioTrack as Ce, HMSLocalVideoTrack as se, HMSRemoteAudioTrack as ls, HMSRemoteVideoTrack as ht } from "@100mslive/hms-video";
var T = /*#__PURE__*/function () {
  function T() {
    _classCallCheck(this, T);
  }
  _createClass(T, null, [{
    key: "convertPeer",
    value: function convertPeer(e) {
      var t, i, o;
      return {
        id: e.peerId,
        name: e.name,
        roleName: (t = e.role) == null ? void 0 : t.name,
        isLocal: e.isLocal,
        videoTrack: (i = e.videoTrack) == null ? void 0 : i.trackId,
        audioTrack: (o = e.audioTrack) == null ? void 0 : o.trackId,
        auxiliaryTracks: e.auxiliaryTracks.map(function (r) {
          return r.trackId;
        }),
        customerUserId: e.customerUserId,
        metadata: e.metadata,
        joinedAt: e.joinedAt
      };
    }
  }, {
    key: "convertTrack",
    value: function convertTrack(e, t) {
      var i = {
        id: e.trackId,
        source: e.source,
        type: e.type,
        enabled: e.enabled,
        displayEnabled: e.enabled,
        peerId: e.peerId || t
      };
      return this.enrichTrack(i, e), i;
    }
  }, {
    key: "enrichTrack",
    value: function enrichTrack(e, t) {
      var i = t.getMediaTrackSettings();
      t instanceof ls && (e.volume = t.getVolume() || 0), T.updateDeviceID(e, t), T.enrichLocalTrack(e, t), e.type === "video" && (e.source === "screen" ? (e.displaySurface = i.displaySurface, T.enrichScreenTrack(e, t)) : e.source === "regular" && (e.facingMode = i.facingMode), e.height = i.height, e.width = i.width, T.enrichVideoTrack(e, t)), T.enrichPluginsDetails(e, t);
    }
  }, {
    key: "enrichLocalTrack",
    value: function enrichLocalTrack(e, t) {
      (t instanceof se || t instanceof Ce) && (e.isPublished = t.isPublished);
    }
  }, {
    key: "updateDeviceID",
    value: function updateDeviceID(e, t) {
      var i;
      t instanceof se || t instanceof Ce ? e.deviceID = t.settings.deviceId : e.deviceID = (i = t.getMediaTrackSettings()) == null ? void 0 : i.deviceId;
    }
  }, {
    key: "enrichVideoTrack",
    value: function enrichVideoTrack(e, t) {
      t instanceof ht && (e.layer = t.getLayer(), e.preferredLayer = t.getPreferredLayer(), e.degraded = t.degraded), (t instanceof ht || t instanceof se) && (U(t.getSimulcastDefinitions(), e.layerDefinitions) || (e.layerDefinitions = t.getSimulcastDefinitions()));
    }
  }, {
    key: "enrichScreenTrack",
    value: function enrichScreenTrack(e, t) {
      var i, o;
      if (t instanceof se) {
        var r = (i = t.getCaptureHandle) == null ? void 0 : i.call(t);
        (r == null ? void 0 : r.handle) !== ((o = e.captureHandle) == null ? void 0 : o.handle) && (e.captureHandle = r), t.isCurrentTab && (e.displaySurface = "selfBrowser");
      }
    }
  }, {
    key: "enrichPluginsDetails",
    value: function enrichPluginsDetails(e, t) {
      (t instanceof se || t instanceof Ce) && (U(t.getPlugins(), e.plugins) || (e.plugins = t.getPlugins()));
    }
  }, {
    key: "convertRoom",
    value: function convertRoom(e) {
      var r, a;
      var _T$convertRecordingSt = T.convertRecordingStreamingState(e == null ? void 0 : e.recording, e == null ? void 0 : e.rtmp, e == null ? void 0 : e.hls),
        t = _T$convertRecordingSt.recording,
        i = _T$convertRecordingSt.rtmp,
        o = _T$convertRecordingSt.hls;
      return {
        id: e.id,
        name: e.name,
        localPeer: (a = (r = e.localPeer) == null ? void 0 : r.peerId) != null ? a : "",
        recording: t,
        rtmp: i,
        hls: o,
        sessionId: e.sessionId,
        startedAt: e.startedAt,
        joinedAt: e.joinedAt,
        peerCount: e.peerCount
      };
    }
  }, {
    key: "convertMessage",
    value: function convertMessage(e) {
      var t, i, o, r, a, n, M;
      return {
        sender: (t = e.sender) == null ? void 0 : t.peerId,
        senderName: (i = e.sender) == null ? void 0 : i.name,
        senderRole: (r = (o = e.sender) == null ? void 0 : o.role) == null ? void 0 : r.name,
        senderUserId: (a = e.sender) == null ? void 0 : a.customerUserId,
        recipientPeer: (n = e.recipientPeer) == null ? void 0 : n.peerId,
        recipientRoles: (M = e.recipientRoles) == null ? void 0 : M.map(function (R) {
          return R.name;
        }),
        time: e.time,
        type: e.type,
        message: e.message
      };
    }
  }, {
    key: "convertRoles",
    value: function convertRoles(e) {
      var t = {};
      return e && e.forEach(function (i) {
        t[i.name] = i;
      }), t;
    }
  }, {
    key: "convertRoleChangeRequest",
    value: function convertRoleChangeRequest(e) {
      var t;
      return {
        requestedBy: (t = e.requestedBy) == null ? void 0 : t.peerId,
        roleName: e.role.name,
        token: e.token
      };
    }
  }, {
    key: "convertException",
    value: function convertException(e) {
      return {
        code: e.code,
        action: e.action,
        name: e.name,
        message: e.message,
        description: e.description,
        isTerminal: e.isTerminal,
        nativeError: e.nativeError,
        timestamp: new Date()
      };
    }
  }, {
    key: "convertDeviceChangeUpdate",
    value: function convertDeviceChangeUpdate(e) {
      var t = {
        devices: e.devices,
        selection: e.selection,
        type: e.type
      };
      return e.error && (t.error = this.convertException(e.error)), t;
    }
  }, {
    key: "convertPlaylist",
    value: function convertPlaylist(e) {
      var t = this.getConvertedPlaylistType(e, p.audio),
        i = this.getConvertedPlaylistType(e, p.video);
      return {
        audio: t,
        video: i
      };
    }
  }, {
    key: "convertPlaylistItem",
    value: function convertPlaylistItem(e, t) {
      var i = t.type,
        o = e.getCurrentSelection(i),
        r = e.isPlaying(i),
        a = t.url === (o == null ? void 0 : o.url);
      return Q(w({}, t), {
        type: t.type,
        selected: a,
        playing: a && r
      });
    }
  }, {
    key: "getConvertedPlaylistType",
    value: function getConvertedPlaylistType(e, t) {
      var i = {},
        o = e.getCurrentSelection(t),
        r = e.getCurrentProgress(t),
        a = e.getVolume(t),
        n = e.getList(t),
        M = e.getCurrentIndex(t);
      return e.getList(t).forEach(function (R) {
        i[R.id] = T.convertPlaylistItem(e, R);
      }), {
        list: i,
        selection: {
          id: o == null ? void 0 : o.id,
          hasPrevious: M > 0,
          hasNext: M < n.length - 1
        },
        progress: r,
        volume: a,
        currentTime: e.getCurrentTime(t),
        playbackRate: e.getPlaybackRate(t)
      };
    }
  }, {
    key: "convertRecordingStreamingState",
    value: function convertRecordingStreamingState(e, t, i) {
      var o;
      return {
        recording: {
          browser: w({
            running: !1
          }, e == null ? void 0 : e.browser),
          server: w({
            running: !1
          }, e == null ? void 0 : e.server),
          hls: w({
            running: !1
          }, e == null ? void 0 : e.hls)
        },
        rtmp: w({
          running: !1
        }, t),
        hls: {
          variants: ((o = i == null ? void 0 : i.variants) == null ? void 0 : o.map(function (r) {
            return r;
          })) || [],
          running: !!(i == null ? void 0 : i.running),
          error: i == null ? void 0 : i.error
        }
      };
    }
  }]);
  return T;
}();
var pe = /*#__PURE__*/function () {
  function pe(e, t, i, o) {
    _classCallCheck(this, pe);
    this.playlistManager = e;
    this.syncPlaylistState = i;
    this.store = o;
    this.type = t;
  }
  _createClass(pe, [{
    key: "play",
    value: function play(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (e) {
                _context.next = 3;
                break;
              }
              u.w("Please pass id to play");
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return this.playlistManager.setEnabled(!0, {
                id: e,
                type: this.type
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "pause",
    value: function pause() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var e, t;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              e = this.type === p.audio ? ot : rt, t = this.store.getState(e.selection);
              if (t.id) {
                _context2.next = 4;
                break;
              }
              u.w("No item is currently playing to pause");
              return _context2.abrupt("return");
            case 4:
              _context2.next = 6;
              return this.playlistManager.setEnabled(!1, {
                id: t.id,
                type: this.type
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "playNext",
    value: function playNext() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.playlistManager.playNext(this.type);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "playPrevious",
    value: function playPrevious() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.playlistManager.playPrevious(this.type);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "seek",
    value: function seek(e) {
      this.playlistManager.seek(e, this.type), this.syncPlaylistState("seekOn".concat(this.type, "Playlist"));
    }
  }, {
    key: "seekTo",
    value: function seekTo(e) {
      this.playlistManager.seekTo(e, this.type), this.syncPlaylistState("seekToOn".concat(this.type, "Playlist"));
    }
  }, {
    key: "setVolume",
    value: function setVolume(e) {
      this.playlistManager.setVolume(e, this.type), this.syncPlaylistState("setVolumeOn".concat(this.type, "Playlist"));
    }
  }, {
    key: "setList",
    value: function setList(e) {
      this.playlistManager.setList(e), this.syncPlaylistState("setListOn".concat(this.type, "Playlist"));
    }
  }, {
    key: "stop",
    value: function stop() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.playlistManager.stop(this.type);
            case 2:
              this.syncPlaylistState("stop".concat(this.type, "Playlist"));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "setIsAutoplayOn",
    value: function setIsAutoplayOn(e) {
      this.playlistManager.setIsAutoplayOn(this.type, e);
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(e) {
      this.playlistManager.setPlaybackRate(this.type, e), this.syncPlaylistState("set".concat(this.type, "PlaybackRate"));
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var t;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.playlistManager.removeItem(e, this.type);
            case 2:
              t = _context6.sent;
              return _context6.abrupt("return", (t && this.syncPlaylistState("remove".concat(this.type, "PlaylistItem")), t));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "clearList",
    value: function clearList() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.playlistManager.clearList(this.type);
            case 2:
              this.syncPlaylistState("clear".concat(this.type, "Playlist"));
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }]);
  return pe;
}();
var Ne = /*#__PURE__*/function () {
  function Ne(e, t, i) {
    var _this2 = this;
    _classCallCheck(this, Ne);
    this.hmsSDKTracks = {};
    this.hmsSDKPeers = {};
    this.isRoomJoinCalled = !1;
    this.ignoredMessageTypes = [];
    this.setProgress = function (_ref) {
      var e = _ref.type,
        t = _ref.progress;
      _this2.setState(function (i) {
        i.playlist[e].progress = t, i.playlist[e].currentTime = _this2.sdk.getPlaylistManager().getCurrentTime(e);
      }, "playlistProgress");
    };
    this.syncPlaylistState = function (e) {
      _this2.setState(function (t) {
        Object.assign(t.playlist, T.convertPlaylist(_this2.sdk.getPlaylistManager()));
      }, e);
    };
    this.sendPeerUpdateNotification = function (e, t) {
      var i = _this2.store.getState(x(t.peerId)),
        o = ae[e] || "peerUpdate";
      _this2.syncRoomState(o), i || (i = _this2.store.getState(x(t.peerId))), _this2.hmsNotifications.sendPeerUpdate(e, i);
    };
    this.setState = function (e, t) {
      return _this2.store.namedSetState(e, t);
    };
    this.store = e, this.sdk = t, this.hmsNotifications = i;
  }
  _createClass(Ne, [{
    key: "refreshDevices",
    value: function refreshDevices() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.sdk.refreshDevices();
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "unblockAudio",
    value: function unblockAudio() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.sdk.getAudioOutput().unblockAutoplay();
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "setVolume",
    value: function setVolume(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!t) {
                _context10.next = 5;
                break;
              }
              _context10.next = 3;
              return this.setTrackVolume(e, t);
            case 3:
              _context10.next = 8;
              break;
            case 5:
              _context10.next = 7;
              return this.sdk.getAudioOutput().setVolume(e);
            case 7:
              this.syncRoomState("setOutputVolume");
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "setAudioOutputDevice",
    value: function setAudioOutputDevice(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.sdk.getAudioOutput().setDevice(e);
            case 2:
              _context11.t0 = _context11.sent;
              if (!_context11.t0) {
                _context11.next = 5;
                break;
              }
              this.setState(function (i) {
                i.settings.audioOutputDeviceId = e;
              }, "setAudioOutputDevice");
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "setPreferredLayer",
    value: function setPreferredLayer(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var o, i;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              i = this.hmsSDKTracks[e];
              if (!i) {
                _context12.next = 17;
                break;
              }
              if (!(i instanceof Ms)) {
                _context12.next = 14;
                break;
              }
              if (!(t === gt.NONE)) {
                _context12.next = 6;
                break;
              }
              u.w("layer ".concat(gt.NONE, " will be ignored"));
              return _context12.abrupt("return");
            case 6:
              if (!(((o = this.store.getState(nt(e))) == null ? void 0 : o.preferredLayer) === t)) {
                _context12.next = 9;
                break;
              }
              u.w("preferred layer is already ".concat(t));
              return _context12.abrupt("return");
            case 9:
              this.setState(function (a) {
                var n = a.tracks[e];
                n && (n.preferredLayer = t);
              }, "setPreferredLayer");
              _context12.next = 12;
              return i.setPreferredLayer(t);
            case 12:
              _context12.next = 15;
              break;
            case 14:
              u.w("track ".concat(e, " is not a remote video track"));
            case 15:
              _context12.next = 18;
              break;
            case 17:
              this.logPossibleInconsistency("track ".concat(e, " not present, unable to set preffer layer"));
            case 18:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "preview",
    value: function preview(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var t;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!this.isRoomJoinCalled) {
                _context13.next = 3;
                break;
              }
              this.logPossibleInconsistency("attempting to call preview after join was called");
              return _context13.abrupt("return");
            case 3:
              t = this.store.getState(b);
              if (!(t === f.Preview || t === f.Connecting)) {
                _context13.next = 7;
                break;
              }
              this.logPossibleInconsistency("attempting to call preview while room is in preview/connecting");
              return _context13.abrupt("return");
            case 7:
              _context13.prev = 7;
              this.setState(function (i) {
                i.room.roomState = f.Connecting;
              }, "connecting");
              _context13.next = 11;
              return this.sdkPreviewWithListeners(e);
            case 11:
              _context13.next = 16;
              break;
            case 13:
              _context13.prev = 13;
              _context13.t0 = _context13["catch"](7);
              throw u.e("Cannot show preview. Failed to connect to room - ", _context13.t0), _context13.t0;
            case 16:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[7, 13]]);
      }));
    }
  }, {
    key: "join",
    value: function join(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!this.isRoomJoinCalled) {
                _context14.next = 3;
                break;
              }
              this.logPossibleInconsistency("room join is called again");
              return _context14.abrupt("return");
            case 3:
              _context14.prev = 3;
              this.isRoomJoinCalled = !0;
              this.setState(function (t) {
                t.room.roomState = f.Connecting;
              }, "join");
              _context14.next = 8;
              return this.sdkJoinWithListeners(e);
            case 8:
              _context14.next = 13;
              break;
            case 10:
              _context14.prev = 10;
              _context14.t0 = _context14["catch"](3);
              throw this.isRoomJoinCalled = !1, u.e("Failed to connect to room - ", _context14.t0), _context14.t0;
            case 13:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[3, 10]]);
      }));
    }
  }, {
    key: "leave",
    value: function leave() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this3 = this;
        var e, t, i;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              e = this.store.getState(he), t = !0;
              e || (t = !1, this.logPossibleInconsistency("room leave is called when no room is connected"));
              i = this.store.getState(b);
              return _context15.abrupt("return", (this.setState(function (o) {
                o.room.roomState = f.Disconnecting;
              }, "leaving"), this.sdk.leave(t).then(function () {
                _this3.resetState("leave"), u.i("left room");
              }).catch(function (o) {
                u.e("error in leaving room - ", o), _this3.setState(function (r) {
                  r.room.roomState = i;
                }, "revertLeave");
              })));
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "setScreenShareEnabled",
    value: function setScreenShareEnabled(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              typeof t == "boolean" && (t = {
                audioOnly: t
              });
              _context16.prev = 1;
              if (!e) {
                _context16.next = 7;
                break;
              }
              _context16.next = 5;
              return this.startScreenShare(t);
            case 5:
              _context16.next = 9;
              break;
            case 7:
              _context16.next = 9;
              return this.stopScreenShare();
            case 9:
              _context16.next = 14;
              break;
            case 11:
              _context16.prev = 11;
              _context16.t0 = _context16["catch"](1);
              throw this.hmsNotifications.sendError(T.convertException(_context16.t0)), _context16.t0;
            case 14:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this, [[1, 11]]);
      }));
    }
  }, {
    key: "addTrack",
    value: function addTrack(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "regular";
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.sdk.addTrack(e, t);
            case 2:
              this.syncRoomState("addTrack");
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "removeTrack",
    value: function removeTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.sdk.removeTrack(e);
            case 2:
              this.syncRoomState("removeTrack");
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "setLocalAudioEnabled",
    value: function setLocalAudioEnabled(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var t;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              t = this.store.getState(C);
              _context19.t0 = t;
              if (!_context19.t0) {
                _context19.next = 5;
                break;
              }
              _context19.next = 5;
              return this.setEnabledTrack(t, e);
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "setLocalVideoEnabled",
    value: function setLocalVideoEnabled(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var t;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              t = this.store.getState(N);
              _context20.t0 = t;
              if (!_context20.t0) {
                _context20.next = 5;
                break;
              }
              _context20.next = 5;
              return this.setEnabledTrack(t, e);
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "setEnabledTrack",
    value: function setEnabledTrack(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this4 = this;
        var r, o;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!(((r = this.store.getState().tracks[e]) == null ? void 0 : r.enabled) === t)) {
                _context21.next = 3;
                break;
              }
              this.logPossibleInconsistency("local track[".concat(e, "] enabled state - ").concat(t));
              return _context21.abrupt("return");
            case 3:
              this.setState(function (a) {
                a.tracks[e] ? a.tracks[e].displayEnabled = t : _this4.logPossibleInconsistency("track id not found for setEnabled");
              }, "displayEnabled");
              _context21.prev = 4;
              _context21.next = 7;
              return this.setEnabledSDKTrack(e, t);
            case 7:
              this.syncRoomState("setEnabled");
              _context21.next = 13;
              break;
            case 10:
              _context21.prev = 10;
              _context21.t0 = _context21["catch"](4);
              throw this.setState(function (n) {
                n.tracks[e].displayEnabled = !t;
              }, "rollbackDisplayEnabled"), this.hmsNotifications.sendError(T.convertException(_context21.t0)), _context21.t0;
            case 13:
              o = t ? A.TRACK_UNMUTED : A.TRACK_MUTED;
              this.hmsNotifications.sendTrackUpdate(o, e);
            case 15:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this, [[4, 10]]);
      }));
    }
  }, {
    key: "setAudioSettings",
    value: function setAudioSettings(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var t;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              t = this.store.getState(C);
              _context22.t0 = t;
              if (!_context22.t0) {
                _context22.next = 6;
                break;
              }
              _context22.next = 5;
              return this.setSDKLocalAudioTrackSettings(t, e);
            case 5:
              this.syncRoomState("setAudioSettings");
            case 6:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "setVideoSettings",
    value: function setVideoSettings(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var t;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              t = this.store.getState(N);
              _context23.t0 = t;
              if (!_context23.t0) {
                _context23.next = 6;
                break;
              }
              _context23.next = 5;
              return this.setSDKLocalVideoTrackSettings(t, e);
            case 5:
              this.syncRoomState("setVideoSettings");
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(e) {
      this.sendBroadcastMessage(e);
    }
  }, {
    key: "sendBroadcastMessage",
    value: function sendBroadcastMessage(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var i;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return this.sdk.sendBroadcastMessage(e, t);
            case 2:
              i = _context24.sent;
              this.updateMessageInStore(i, {
                message: e,
                type: t
              });
            case 4:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
    }
  }, {
    key: "sendGroupMessage",
    value: function sendGroupMessage(e, t, i) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var o, r, a;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              o = this.store.getState(_);
              r = t.map(function (n) {
                return o[n];
              });
              _context25.next = 4;
              return this.sdk.sendGroupMessage(e, r, i);
            case 4:
              a = _context25.sent;
              this.updateMessageInStore(a, {
                message: e,
                recipientRoles: t,
                type: i
              });
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
    }
  }, {
    key: "sendDirectMessage",
    value: function sendDirectMessage(e, t, i) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var o, r;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              o = this.hmsSDKPeers[t];
              _context26.next = 3;
              return this.sdk.sendDirectMessage(e, o, i);
            case 3:
              r = _context26.sent;
              this.updateMessageInStore(r, {
                message: e,
                recipientPeer: o.peerId,
                type: i
              });
            case 5:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
    }
  }, {
    key: "updateMessageInStore",
    value: function updateMessageInStore(e, t) {
      if (!e) throw u.w("sendMessage", "Failed to send message", t), Error("sendMessage Failed - ".concat(JSON.stringify(t)));
      var i = T.convertMessage(e);
      return i.read = !0, i.senderName = "You", i.ignored = this.ignoredMessageTypes.includes(i.type), this.putMessageInStore(i), i;
    }
  }, {
    key: "setMessageRead",
    value: function setMessageRead(e, t) {
      var _this5 = this;
      this.setState(function (i) {
        t ? i.messages.byID[t] ? i.messages.byID[t].read = e : _this5.logPossibleInconsistency("no message with id is found") : i.messages.allIDs.forEach(function (o) {
          i.messages.byID[o].read = e;
        });
      }, "setMessageRead");
    }
  }, {
    key: "attachVideo",
    value: function attachVideo(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!this.localAndVideoUnmuting(e)) {
                _context28.next = 2;
                break;
              }
              return _context28.abrupt("return", new Promise(function (i) {
                var o = _this6.store.subscribe(function (r) {
                  return c(_this6, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
                    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                      while (1) switch (_context27.prev = _context27.next) {
                        case 0:
                          _context27.t0 = r;
                          if (!_context27.t0) {
                            _context27.next = 6;
                            break;
                          }
                          _context27.next = 4;
                          return this.attachVideoInternal(e, t);
                        case 4:
                          o();
                          i();
                        case 6:
                        case "end":
                          return _context27.stop();
                      }
                    }, _callee27, this);
                  }));
                }, ge);
              }));
            case 2:
              _context28.next = 4;
              return this.attachVideoInternal(e, t);
            case 4:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
    }
  }, {
    key: "detachVideo",
    value: function detachVideo(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var i;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              i = this.hmsSDKTracks[e];
              (i == null ? void 0 : i.type) === "video" ? i.removeSink(t) : (t && (t.srcObject = null), this.logPossibleInconsistency("no video track found to remove sink"));
            case 2:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
    }
  }, {
    key: "addPluginToVideoTrack",
    value: function addPluginToVideoTrack(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              return _context30.abrupt("return", this.addRemoveVideoPlugin(e, "add", t));
            case 1:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "addPluginToAudioTrack",
    value: function addPluginToAudioTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              return _context31.abrupt("return", this.addRemoveAudioPlugin(e, "add"));
            case 1:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
    }
  }, {
    key: "validateVideoPluginSupport",
    value: function validateVideoPluginSupport(e) {
      var t = {};
      if (t.isSupported = !1, !e) return u.w("no plugin passed in for checking support"), t.errMsg = "no plugin passed in for checking support", t;
      var i = this.store.getState(N);
      if (!i) return u.w("video Track not added to local peer yet"), t.errMsg = "call this function only after local peer has video track", t;
      var o = this.hmsSDKTracks[i];
      return o ? t = o.validatePlugin(e) : (u.w("track ".concat(i, " not present, unable to validate plugin")), t.errMsg = "track ".concat(i, " not present, unable to validate plugin")), t;
    }
  }, {
    key: "validateAudioPluginSupport",
    value: function validateAudioPluginSupport(e) {
      var t = {};
      if (t.isSupported = !1, !e) return u.w('no plugin passed in for checking support"'), t.errMsg = 'no plugin passed in for checking support"', t;
      var i = this.store.getState(C);
      if (!i) return u.w("audio track not added to local peer yet"), t.errMsg = "call this function only after local peer has audio track", t;
      var o = this.hmsSDKTracks[i];
      return o ? t = o.validatePlugin(e) : (u.w("track ".concat(i, " not present, unable to validate plugin")), t.errMsg = "track ".concat(i, " not present, unable to validate plugin")), t;
    }
  }, {
    key: "removePluginFromVideoTrack",
    value: function removePluginFromVideoTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              return _context32.abrupt("return", this.addRemoveVideoPlugin(e, "remove"));
            case 1:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
    }
  }, {
    key: "removePluginFromAudioTrack",
    value: function removePluginFromAudioTrack(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              return _context33.abrupt("return", this.addRemoveAudioPlugin(e, "remove"));
            case 1:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
    }
  }, {
    key: "changeRole",
    value: function changeRole(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var o;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              o = this.hmsSDKPeers[e];
              if (o) {
                _context34.next = 4;
                break;
              }
              this.logPossibleInconsistency("Unknown peer ID given ".concat(e, " for changerole"));
              return _context34.abrupt("return");
            case 4:
              _context34.next = 6;
              return this.sdk.changeRoleOfPeer(o, t, i);
            case 6:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "changeRoleOfPeer",
    value: function changeRoleOfPeer(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var o;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              o = this.hmsSDKPeers[e];
              if (o) {
                _context35.next = 4;
                break;
              }
              this.logPossibleInconsistency("Unknown peer ID given ".concat(e, " for changerole"));
              return _context35.abrupt("return");
            case 4:
              _context35.next = 6;
              return this.sdk.changeRoleOfPeer(o, t, i);
            case 6:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "changeRoleOfPeersWithRoles",
    value: function changeRoleOfPeersWithRoles(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var i;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              i = this.sdk.getRoles().filter(function (o) {
                return e.includes(o.name);
              });
              _context36.next = 3;
              return this.sdk.changeRoleOfPeersWithRoles(i, t);
            case 3:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
    }
  }, {
    key: "acceptChangeRole",
    value: function acceptChangeRole(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              t = e.requestedBy ? this.hmsSDKPeers[e.requestedBy.id] : void 0;
              t || u.w("peer for which role change is requested no longer available - ".concat(e.requestedBy));
              i = {
                requestedBy: t,
                role: e.role,
                token: e.token
              };
              _context37.next = 5;
              return this.sdk.acceptChangeRole(i);
            case 5:
              this.removeRoleChangeRequest(e);
            case 6:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "initAppData",
    value: function initAppData(e) {
      this.setState(function (t) {
        t.appData = e;
      }, "initAppData");
    }
  }, {
    key: "setAppData",
    value: function setAppData(e, t, i) {
      var o = (t == null ? void 0 : t.constructor.name) === "Object";
      this.setState(function (r) {
        if (r.appData) i && o ? Object.assign(r.appData[e], t) : r.appData[e] = t;else {
          var a = _defineProperty({}, e, t);
          r.appData = a;
        }
      }, "setAppData-".concat(e));
    }
  }, {
    key: "rejectChangeRole",
    value: function rejectChangeRole(e) {
      this.removeRoleChangeRequest(e);
    }
  }, {
    key: "endRoom",
    value: function endRoom(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var i, o;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              i = this.store.getState(Je);
              if (i == null ? void 0 : i.endRoom) {
                _context38.next = 4;
                break;
              }
              u.w("You are not allowed to perform this action - endRoom");
              return _context38.abrupt("return");
            case 4:
              o = this.store.getState(b);
              this.setState(function (r) {
                r.room.roomState = f.Disconnecting;
              }, "endingRoom");
              _context38.prev = 6;
              _context38.next = 9;
              return this.sdk.endRoom(e, t);
            case 9:
              this.resetState("endRoom");
              _context38.next = 15;
              break;
            case 12:
              _context38.prev = 12;
              _context38.t0 = _context38["catch"](6);
              u.e("error in ending room - ", _context38.t0), this.setState(function (a) {
                a.room.roomState = o;
              }, "revertEndRoom");
            case 15:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this, [[6, 12]]);
      }));
    }
  }, {
    key: "removePeer",
    value: function removePeer(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var i;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              i = this.hmsSDKPeers[e];
              if (!(i && !i.isLocal)) {
                _context39.next = 6;
                break;
              }
              _context39.next = 4;
              return this.sdk.removePeer(i, t);
            case 4:
              _context39.next = 8;
              break;
            case 6:
              this.logPossibleInconsistency("No remote peer found for peerID - ".concat(e));
              return _context39.abrupt("return");
            case 8:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this);
      }));
    }
  }, {
    key: "startRTMPOrRecording",
    value: function startRTMPOrRecording(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return this.sdk.startRTMPOrRecording(e);
            case 2:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "stopRTMPAndRecording",
    value: function stopRTMPAndRecording() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return this.sdk.stopRTMPAndRecording();
            case 2:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "startHLSStreaming",
    value: function startHLSStreaming(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return this.sdk.startHLSStreaming(e);
            case 2:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
    }
  }, {
    key: "stopHLSStreaming",
    value: function stopHLSStreaming(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.sdk.stopHLSStreaming(e);
            case 2:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "sendHLSTimedMetadata",
    value: function sendHLSTimedMetadata(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return this.sdk.sendHLSTimedMetadata(e);
            case 2:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "changeName",
    value: function changeName(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return this.sdk.changeName(e);
            case 2:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
    }
  }, {
    key: "changeMetadata",
    value: function changeMetadata(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              typeof e != "string" && (e = JSON.stringify(e));
              _context46.next = 3;
              return this.sdk.changeMetadata(e);
            case 3:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
    }
  }, {
    key: "setSessionMetadata",
    value: function setSessionMetadata(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return this.sdk.setSessionMetadata(e);
            case 2:
              this.setState(function (t) {
                t.sessionMetadata = e;
              }, "setSessionMetadata");
            case 3:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this);
      }));
    }
  }, {
    key: "populateSessionMetadata",
    value: function populateSessionMetadata() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var e;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return this.sdk.getSessionMetadata();
            case 2:
              e = _context48.sent;
              this.setState(function (t) {
                t.sessionMetadata = e;
              }, "populateSessionMetadata");
            case 4:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
    }
  }, {
    key: "setRemoteTrackEnabled",
    value: function setRemoteTrackEnabled(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        var _this7 = this;
        var i;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!(typeof e == "string")) {
                _context49.next = 10;
                break;
              }
              i = this.hmsSDKTracks[e];
              if (!(i && Tt(i))) {
                _context49.next = 7;
                break;
              }
              _context49.next = 5;
              return this.sdk.changeTrackState(i, t);
            case 5:
              _context49.next = 8;
              break;
            case 7:
              this.logPossibleInconsistency("No remote track with ID ".concat(e, " found for change track state"));
            case 8:
              _context49.next = 11;
              break;
            case 10:
              Array.isArray(e) && e.forEach(function (i) {
                return _this7.setRemoteTrackEnabled(i, t);
              });
            case 11:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
    }
  }, {
    key: "setRemoteTracksEnabled",
    value: function setRemoteTracksEnabled(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
        var t, i;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              t = {
                enabled: e.enabled,
                type: e.type,
                source: e.source
              };
              if (e.roles) {
                i = this.store.getState(_);
                t.roles = e.roles.map(function (o) {
                  return i[o];
                });
              }
              _context50.next = 4;
              return this.sdk.changeMultiTrackState(t);
            case 4:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(e) {
      u.level = e, this.sdk.setLogLevel(e);
    }
  }, {
    key: "setFrameworkInfo",
    value: function setFrameworkInfo(e) {
      this.sdk.setFrameworkInfo(e);
    }
  }, {
    key: "ignoreMessageTypes",
    value: function ignoreMessageTypes(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (t) this.ignoredMessageTypes = e;else {
        var _iterator9 = _createForOfIteratorHelper(e),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var i = _step9.value;
            this.ignoredMessageTypes.includes(i) || this.ignoredMessageTypes.push(i);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
    }
  }, {
    key: "resetState",
    value: function resetState() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "resetState";
      this.isRoomJoinCalled = !1, this.hmsSDKTracks = {}, u.cleanUp(), this.setState(function (t) {
        Object.assign(t, ie());
      }, e);
    }
  }, {
    key: "sdkJoinWithListeners",
    value: function sdkJoinWithListeners(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _context51.next = 2;
              return this.sdk.join(e, {
                onJoin: this.onJoin.bind(this),
                onRoomUpdate: this.onRoomUpdate.bind(this),
                onPeerUpdate: this.onPeerUpdate.bind(this),
                onTrackUpdate: this.onTrackUpdate.bind(this),
                onMessageReceived: this.onMessageReceived.bind(this),
                onError: this.onError.bind(this),
                onReconnected: this.onReconnected.bind(this),
                onReconnecting: this.onReconnecting.bind(this),
                onRoleChangeRequest: this.onRoleChangeRequest.bind(this),
                onRoleUpdate: this.onRoleUpdate.bind(this),
                onDeviceChange: this.onDeviceChange.bind(this),
                onChangeTrackStateRequest: this.onChangeTrackStateRequest.bind(this),
                onChangeMultiTrackStateRequest: this.onChangeMultiTrackStateRequest.bind(this),
                onRemovedFromRoom: this.onRemovedFromRoom.bind(this),
                onNetworkQuality: this.onNetworkQuality.bind(this)
              });
            case 2:
              this.sdk.addAudioListener({
                onAudioLevelUpdate: this.onAudioLevelUpdate.bind(this)
              });
              this.sdk.addConnectionQualityListener({
                onConnectionQualityUpdate: this.onConnectionQualityUpdate.bind(this)
              });
            case 4:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this);
      }));
    }
  }, {
    key: "onRemovedFromRoom",
    value: function onRemovedFromRoom(e) {
      var o;
      var t = this.store.getState(x((o = e.requestedBy) == null ? void 0 : o.peerId));
      this.hmsNotifications.sendLeaveRoom(Q(w({}, e), {
        requestedBy: t || void 0
      }));
      var i = e.roomEnded || !t ? "roomEnded" : "removedFromRoom";
      u.i("resetting state after peer removed ".concat(i), e), this.resetState(i);
    }
  }, {
    key: "onDeviceChange",
    value: function onDeviceChange(e) {
      var _this8 = this;
      var t = e.devices;
      if (!t) return;
      var i = this.store.getState(E);
      if (this.setState(function (o) {
        U(o.devices.audioInput, t.audioInput) || (o.devices.audioInput = t.audioInput), U(o.devices.videoInput, t.videoInput) || (o.devices.videoInput = t.videoInput), U(o.devices.audioOutput, t.audioOutput) || (o.devices.audioOutput = t.audioOutput), (i == null ? void 0 : i.id) && _this8.hmsSDKPeers[i.id] && Object.assign(o.settings, _this8.getMediaSettings(_this8.hmsSDKPeers[i.id]));
      }, "deviceChange"), e.selection) {
        var o = T.convertDeviceChangeUpdate(e);
        this.hmsNotifications.sendDeviceChange(o);
      }
    }
  }, {
    key: "sdkPreviewWithListeners",
    value: function sdkPreviewWithListeners(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              _context52.next = 2;
              return this.sdk.preview(e, {
                onPreview: this.onPreview.bind(this),
                onError: this.onError.bind(this),
                onReconnected: this.onReconnected.bind(this),
                onReconnecting: this.onReconnecting.bind(this),
                onDeviceChange: this.onDeviceChange.bind(this),
                onRoomUpdate: this.onRoomUpdate.bind(this),
                onPeerUpdate: this.onPeerUpdate.bind(this),
                onNetworkQuality: this.onNetworkQuality.bind(this)
              });
            case 2:
              this.sdk.addAudioListener({
                onAudioLevelUpdate: this.onAudioLevelUpdate.bind(this)
              });
            case 3:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this);
      }));
    }
  }, {
    key: "onNetworkQuality",
    value: function onNetworkQuality(e) {
      var _this9 = this;
      this.setState(function (t) {
        var o;
        var i = t.room.localPeer || ((o = _this9.sdk.getLocalPeer()) == null ? void 0 : o.peerId);
        i && (t.connectionQualities[i] = {
          peerID: i,
          downlinkQuality: e
        });
      }, "ConnectionQuality");
    }
  }, {
    key: "startScreenShare",
    value: function startScreenShare(e) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        var _this10 = this;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              if (!this.store.getState(ye)) {
                _context53.next = 4;
                break;
              }
              this.logPossibleInconsistency("start screenshare is called while it's on");
              _context53.next = 7;
              break;
            case 4:
              _context53.next = 6;
              return this.sdk.startScreenShare(function () {
                return _this10.syncRoomState("screenshareStopped");
              }, e);
            case 6:
              this.syncRoomState("startScreenShare");
            case 7:
            case "end":
              return _context53.stop();
          }
        }, _callee53, this);
      }));
    }
  }, {
    key: "stopScreenShare",
    value: function stopScreenShare() {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              if (!this.store.getState(ye)) {
                _context54.next = 6;
                break;
              }
              _context54.next = 3;
              return this.sdk.stopScreenShare();
            case 3:
              this.syncRoomState("stopScreenShare");
              _context54.next = 7;
              break;
            case 6:
              this.logPossibleInconsistency("stop screenshare is called while it's not on");
            case 7:
            case "end":
              return _context54.stop();
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "attachVideoInternal",
    value: function attachVideoInternal(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
        var i;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              i = this.hmsSDKTracks[e];
              if (!(i && i.type === "video")) {
                _context55.next = 6;
                break;
              }
              _context55.next = 4;
              return i.addSink(t);
            case 4:
              _context55.next = 7;
              break;
            case 6:
              this.logPossibleInconsistency("no video track found to add sink");
            case 7:
            case "end":
              return _context55.stop();
          }
        }, _callee55, this);
      }));
    }
  }, {
    key: "syncRoomState",
    value: function syncRoomState(e) {
      var _this11 = this;
      e = "".concat(e, "_fullSync"), u.time("store-sync-".concat(e));
      var t = {},
        i = [],
        o = {},
        r = {},
        a = {},
        n,
        M = this.sdk.getPeers();
      var _iterator10 = _createForOfIteratorHelper(M),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var g = _step10.value;
          var q = T.convertPeer(g);
          t[q.id] = q, i.push(q.id), this.hmsSDKPeers[q.id] = g;
          var He = [g.audioTrack, g.videoTrack].concat(_toConsumableArray(g.auxiliaryTracks));
          var _iterator11 = _createForOfIteratorHelper(He),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _O = _step11.value;
              if (!_O) continue;
              var we = T.convertTrack(_O);
              o[we.id] = we, r[_O.trackId] = _O;
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
          if (g.isLocal) {
            var O = g;
            n = this.getPreviewFields(O), Object.assign(a, this.getMediaSettings(O));
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      var R = this.sdk.getRecordingState(),
        j = this.sdk.getRTMPState(),
        F = this.sdk.getHLSState();
      this.setState(function (g) {
        var O;
        g.room.peers = i;
        var q = g.peers,
          He = g.tracks;
        mt(q, t), Ht(He, o), Object.assign(g.settings, a), _this11.hmsSDKTracks = r, ((O = g.preview) == null ? void 0 : O.localPeer) && (n == null ? void 0 : n.localPeer) ? Object.assign(g.preview, n) : g.preview = n, Object.assign(g.roles, T.convertRoles(_this11.sdk.getRoles())), Object.assign(g.playlist, T.convertPlaylist(_this11.sdk.getPlaylistManager())), Object.assign(g.room, T.convertRecordingStreamingState(R, j, F));
      }, e), u.timeEnd("store-sync-".concat(e));
    }
  }, {
    key: "onPreview",
    value: function onPreview(e) {
      this.setState(function (t) {
        Object.assign(t.room, T.convertRoom(e)), t.room.roomState = f.Preview;
      }, "previewStart"), this.syncRoomState("previewSync");
    }
  }, {
    key: "onJoin",
    value: function onJoin(e) {
      var _this12 = this;
      var t = this.sdk.getPlaylistManager();
      this.audioPlaylist = new pe(t, p.audio, this.syncPlaylistState.bind(this), this.store), this.videoPlaylist = new pe(t, p.video, this.syncRoomState.bind(this), this.store), this.syncRoomState("joinSync"), this.setState(function (i) {
        Object.assign(i.room, T.convertRoom(e)), i.room.isConnected = !0, i.room.roomState = f.Connected;
      }, "joined"), t.onProgress(this.setProgress), t.onNewTrackStart(function (i) {
        _this12.syncPlaylistState("".concat(i.type, "PlaylistUpdate"));
      }), t.onPlaylistEnded(function (i) {
        _this12.syncPlaylistState("".concat(i, "PlaylistEnded"));
      }), t.onCurrentTrackEnded(function (i) {
        _this12.hmsNotifications.sendPlaylistTrackEnded(T.convertPlaylistItem(t, i)), _this12.syncPlaylistState("".concat(i.type, "PlaylistItemEnded"));
      });
    }
  }, {
    key: "onRoomUpdate",
    value: function onRoomUpdate(e, t) {
      this.setState(function (i) {
        Object.assign(i.room, T.convertRoom(t));
      }, e);
    }
  }, {
    key: "onPeerUpdate",
    value: function onPeerUpdate(e, t) {
      if (![K.BECAME_DOMINANT_SPEAKER, K.RESIGNED_DOMINANT_SPEAKER].includes(e)) {
        if (Array.isArray(t)) {
          this.syncRoomState("peersJoined");
          var i = [];
          var _iterator12 = _createForOfIteratorHelper(t),
            _step12;
          try {
            for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
              var o = _step12.value;
              var r = this.store.getState(x(o.peerId));
              r && i.push(r);
            }
          } catch (err) {
            _iterator12.e(err);
          } finally {
            _iterator12.f();
          }
          this.hmsNotifications.sendPeerList(i);
          return;
        }
        this.sendPeerUpdateNotification(e, t);
      }
    }
  }, {
    key: "onTrackUpdate",
    value: function onTrackUpdate(e, t, i) {
      if (e === A.TRACK_REMOVED) this.hmsNotifications.sendTrackUpdate(e, t.trackId), this.handleTrackRemove(t, i);else {
        var o = ne[e] || "trackUpdate";
        this.syncRoomState(o), this.hmsNotifications.sendTrackUpdate(e, t.trackId);
      }
    }
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(e) {
      var t = T.convertMessage(e);
      t.read = !1, t.ignored = this.ignoredMessageTypes.includes(t.type), this.putMessageInStore(t), this.hmsNotifications.sendMessageReceived(t);
    }
  }, {
    key: "putMessageInStore",
    value: function putMessageInStore(e) {
      var _this13 = this;
      e.ignored || this.setState(function (t) {
        e.id = String(_this13.store.getState(We) + 1), t.messages.byID[e.id] = e, t.messages.allIDs.push(e.id);
      }, "newMessage");
    }
  }, {
    key: "onAudioLevelUpdate",
    value: function onAudioLevelUpdate(e) {
      this.setState(function (t) {
        var i = {};
        e.forEach(function (r) {
          if (!r.track || !r.peer) return;
          var a = r.track.trackId;
          i[a] = r.audioLevel, t.speakers[a] || (t.speakers[a] = {
            audioLevel: r.audioLevel,
            peerID: r.peer.peerId,
            trackID: a
          });
        });
        var o = Object.entries(t.speakers);
        for (var _i3 = 0, _o = o; _i3 < _o.length; _i3++) {
          var _o$_i = _slicedToArray(_o[_i3], 2),
            r = _o$_i[0],
            a = _o$_i[1];
          a.audioLevel = i[r] || 0, a.audioLevel === 0 && delete t.speakers[r];
        }
      }, "audioLevel");
    }
  }, {
    key: "onConnectionQualityUpdate",
    value: function onConnectionQualityUpdate(e) {
      this.setState(function (t) {
        var i = new Set();
        e.forEach(function (r) {
          var a = r.peerID;
          !a || (i.add(a), t.connectionQualities[a] ? Object.assign(t.connectionQualities[a], r) : t.connectionQualities[a] = r);
        });
        var o = Object.keys(t.connectionQualities);
        for (var _i4 = 0, _o2 = o; _i4 < _o2.length; _i4++) {
          var r = _o2[_i4];
          i.has(r) || delete t.connectionQualities[r];
        }
      }, "connectionQuality");
    }
  }, {
    key: "onChangeTrackStateRequest",
    value: function onChangeTrackStateRequest(e) {
      var r;
      var t = this.store.getState(x((r = e.requestedBy) == null ? void 0 : r.peerId)),
        i = this.getStoreLocalTrackIDfromSDKTrack(e.track),
        o = this.store.getState(de(i));
      if (!o) return this.logPossibleInconsistency("Not found track for which track state change was requested, ".concat(e.track));
      e.enabled || this.syncRoomState("changeTrackStateRequest"), this.hmsNotifications.sendChangeTrackStateRequest({
        requestedBy: t || void 0,
        track: o,
        enabled: e.enabled
      });
    }
  }, {
    key: "onChangeMultiTrackStateRequest",
    value: function onChangeMultiTrackStateRequest(e) {
      var r;
      var t = this.store.getState(x((r = e.requestedBy) == null ? void 0 : r.peerId));
      e.enabled || this.syncRoomState("changeMultiTrackStateRequest");
      var i = [],
        o = this.store.getState(h);
      var _iterator13 = _createForOfIteratorHelper(e.tracks),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var a = _step13.value;
          var n = this.getStoreLocalTrackIDfromSDKTrack(a);
          n && o[n] && i.push(o[n]);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      this.hmsNotifications.sendChangeMultiTrackStateRequest({
        requestedBy: t || void 0,
        tracks: i,
        enabled: e.enabled,
        type: e.type,
        source: e.source
      });
    }
  }, {
    key: "onReconnected",
    value: function onReconnected() {
      this.syncRoomState("reconnectedSync"), this.hmsNotifications.sendReconnected(), this.setState(function (e) {
        e.room.roomState = e.room.isConnected ? f.Connected : f.Preview;
      }, "reconnected");
    }
  }, {
    key: "onReconnecting",
    value: function onReconnecting(e) {
      var t = T.convertException(e);
      u.e("Reconnection: received error from sdk", t), this.hmsNotifications.sendReconnecting(t), this.setState(function (i) {
        i.room.roomState = f.Reconnecting, i.errors.push(t);
      }, "reconnecting");
    }
  }, {
    key: "onError",
    value: function onError(e) {
      var t = T.convertException(e);
      t.isTerminal ? (this.leave().then(function () {
        return u.e("error from SDK, left room.");
      }), this.setState(function (i) {
        i.room.roomState = f.Failed, i.errors.push(t);
      }, "errorTerminal")) : this.store.getState().errors.length < 50 && this.setState(function (o) {
        o.errors.push(t);
      }, "error"), this.syncRoomState("errorSync"), this.hmsNotifications.sendError(t), u.e("received error from sdk", t instanceof us ? "".concat(t) : t);
    }
  }, {
    key: "handleTrackRemove",
    value: function handleTrackRemove(e, t) {
      var _this14 = this;
      this.setState(function (i) {
        var o = i.peers[t.peerId],
          r = i.tracks,
          a = e.trackId;
        if (_this14.isSameStoreSDKTrack(a, o == null ? void 0 : o.audioTrack)) o == null || delete o.audioTrack;else if (_this14.isSameStoreSDKTrack(a, o == null ? void 0 : o.videoTrack)) o == null || delete o.videoTrack;else {
          var n = o == null ? void 0 : o.auxiliaryTracks.indexOf(a);
          n > -1 && _this14.isSameStoreSDKTrack(a, o == null ? void 0 : o.auxiliaryTracks[n]) && (o == null || o.auxiliaryTracks.splice(n, 1));
        }
        delete r[a], delete _this14.hmsSDKTracks[a];
      }, "trackRemoved");
    }
  }, {
    key: "setEnabledSDKTrack",
    value: function setEnabledSDKTrack(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var i;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              i = this.hmsSDKTracks[e];
              if (!i) {
                _context56.next = 6;
                break;
              }
              _context56.next = 4;
              return i.setEnabled(t);
            case 4:
              _context56.next = 7;
              break;
            case 6:
              this.logPossibleInconsistency("track ".concat(e, " not present, unable to enabled/disable"));
            case 7:
            case "end":
              return _context56.stop();
          }
        }, _callee56, this);
      }));
    }
  }, {
    key: "setSDKLocalVideoTrackSettings",
    value: function setSDKLocalVideoTrackSettings(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var i;
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              i = this.hmsSDKTracks[e];
              if (!i) {
                _context57.next = 6;
                break;
              }
              _context57.next = 4;
              return i.setSettings(t);
            case 4:
              _context57.next = 7;
              break;
            case 6:
              this.logPossibleInconsistency("local track ".concat(e, " not present, unable to set settings"));
            case 7:
            case "end":
              return _context57.stop();
          }
        }, _callee57, this);
      }));
    }
  }, {
    key: "setSDKLocalAudioTrackSettings",
    value: function setSDKLocalAudioTrackSettings(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var i;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              i = this.hmsSDKTracks[e];
              if (!i) {
                _context58.next = 6;
                break;
              }
              _context58.next = 4;
              return i.setSettings(t);
            case 4:
              _context58.next = 7;
              break;
            case 6:
              this.logPossibleInconsistency("local track ".concat(e, " not present, unable to set settings"));
            case 7:
            case "end":
              return _context58.stop();
          }
        }, _callee58, this);
      }));
    }
  }, {
    key: "getMediaSettings",
    value: function getMediaSettings(e) {
      var r;
      var t = this.store.getState(Fe),
        i = e.audioTrack,
        o = e.videoTrack;
      return {
        audioInputDeviceId: (i == null ? void 0 : i.settings.deviceId) || t.audioInputDeviceId,
        videoInputDeviceId: (o == null ? void 0 : o.settings.deviceId) || t.videoInputDeviceId,
        audioOutputDeviceId: (r = this.sdk.getAudioOutput().getDevice()) == null ? void 0 : r.deviceId
      };
    }
  }, {
    key: "getPreviewFields",
    value: function getPreviewFields(e) {
      var i, o;
      if (!e.isInPreview()) return;
      var t = T.convertPeer(e);
      return {
        localPeer: t.id,
        audioTrack: t.audioTrack,
        videoTrack: t.videoTrack,
        asRole: ((i = e.asRole) == null ? void 0 : i.name) || ((o = e.role) == null ? void 0 : o.name)
      };
    }
  }, {
    key: "setTrackVolume",
    value: function setTrackVolume(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        var i;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              i = this.hmsSDKTracks[t];
              if (!i) {
                _context59.next = 11;
                break;
              }
              if (!(i instanceof ds)) {
                _context59.next = 8;
                break;
              }
              _context59.next = 5;
              return i.setVolume(e);
            case 5:
              this.setState(function (o) {
                var r = o.tracks[t];
                r && r.type === "audio" && (r.volume = e);
              }, "trackVolume");
              _context59.next = 9;
              break;
            case 8:
              u.w("track ".concat(t, " is not an audio track"));
            case 9:
              _context59.next = 12;
              break;
            case 11:
              this.logPossibleInconsistency("track ".concat(t, " not present, unable to set volume"));
            case 12:
            case "end":
              return _context59.stop();
          }
        }, _callee59, this);
      }));
    }
  }, {
    key: "localAndVideoUnmuting",
    value: function localAndVideoUnmuting(e) {
      var t = this.store.getState(E);
      if ((t == null ? void 0 : t.videoTrack) !== e) return !1;
      var i = this.store.getState(Ge),
        o = this.store.getState(ge);
      return i && !o;
    }
  }, {
    key: "logPossibleInconsistency",
    value: function logPossibleInconsistency(e) {
      u.w("possible inconsistency detected - ", e);
    }
  }, {
    key: "addRemoveVideoPlugin",
    value: function addRemoveVideoPlugin(e, t, i) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
        var o, r;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              if (e) {
                _context60.next = 3;
                break;
              }
              u.w("Invalid plugin received in store");
              return _context60.abrupt("return");
            case 3:
              o = this.store.getState(N);
              if (!o) {
                _context60.next = 20;
                break;
              }
              r = this.hmsSDKTracks[o];
              if (!r) {
                _context60.next = 19;
                break;
              }
              if (!(t === "add")) {
                _context60.next = 12;
                break;
              }
              _context60.next = 10;
              return r.addPlugin(e, i);
            case 10:
              _context60.next = 16;
              break;
            case 12:
              _context60.t0 = t === "remove";
              if (!_context60.t0) {
                _context60.next = 16;
                break;
              }
              _context60.next = 16;
              return r.removePlugin(e);
            case 16:
              this.syncRoomState("".concat(t, "VideoPlugin"));
              _context60.next = 20;
              break;
            case 19:
              this.logPossibleInconsistency("track ".concat(o, " not present, unable to remove plugin"));
            case 20:
            case "end":
              return _context60.stop();
          }
        }, _callee60, this);
      }));
    }
  }, {
    key: "addRemoveAudioPlugin",
    value: function addRemoveAudioPlugin(e, t) {
      return c(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
        var i, o;
        return _regeneratorRuntime().wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              if (e) {
                _context61.next = 3;
                break;
              }
              u.w("Invalid plugin received in store");
              return _context61.abrupt("return");
            case 3:
              i = this.store.getState(C);
              if (!i) {
                _context61.next = 20;
                break;
              }
              o = this.hmsSDKTracks[i];
              if (!o) {
                _context61.next = 19;
                break;
              }
              if (!(t === "add")) {
                _context61.next = 12;
                break;
              }
              _context61.next = 10;
              return o.addPlugin(e);
            case 10:
              _context61.next = 16;
              break;
            case 12:
              _context61.t0 = t === "remove";
              if (!_context61.t0) {
                _context61.next = 16;
                break;
              }
              _context61.next = 16;
              return o.removePlugin(e);
            case 16:
              this.syncRoomState("".concat(t, "AudioPlugin"));
              _context61.next = 20;
              break;
            case 19:
              this.logPossibleInconsistency("track ".concat(i, " not present, unable to remove plugin"));
            case 20:
            case "end":
              return _context61.stop();
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "isSameStoreSDKTrack",
    value: function isSameStoreSDKTrack(e, t) {
      var i;
      return t ? ((i = this.hmsSDKTracks[t]) == null ? void 0 : i.trackId) === e : !1;
    }
  }, {
    key: "onRoleChangeRequest",
    value: function onRoleChangeRequest(e) {
      this.setState(function (t) {
        t.roleChangeRequests.length === 0 && t.roleChangeRequests.push(T.convertRoleChangeRequest(e));
      }, "roleChangeRequest");
    }
  }, {
    key: "removeRoleChangeRequest",
    value: function removeRoleChangeRequest(e) {
      this.setState(function (t) {
        var i = t.roleChangeRequests.findIndex(function (o) {
          return o.token === e.token;
        });
        i !== -1 && t.roleChangeRequests.splice(i, 1);
      }, "removeRoleChangeRequest");
    }
  }, {
    key: "onRoleUpdate",
    value: function onRoleUpdate() {
      this.syncRoomState("roleUpdate");
    }
  }, {
    key: "getStoreLocalTrackIDfromSDKTrack",
    value: function getStoreLocalTrackIDfromSDKTrack(e) {
      var _this15 = this;
      return this.store.getState($e).find(function (i) {
        return _this15.hmsSDKTracks[i].trackId === e.trackId;
      });
    }
  }]);
  return Ne;
}();
import { isBrowser as ps } from "@100mslive/hms-video";
var Te = function Te(s) {
  return ps ? "".concat(s, " ").concat(document.title) : s;
};
var xe = /*#__PURE__*/function () {
  function xe(e, t, i) {
    _classCallCheck(this, xe);
    this.store = e, this.actions = t, this.notifications = i;
  }
  _createClass(xe, [{
    key: "getStore",
    value: function getStore() {
      return this.store;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return this.actions;
    }
  }, {
    key: "getNotifications",
    value: function getNotifications() {
      return {
        onNotification: this.notifications.onNotification
      };
    }
  }]);
  return xe;
}();
var yt = function yt(s, e, t) {
    var i;
    t.getState(b) === f.Connected && (i = kt(s, e, t)), t.subscribe(function (o) {
      [f.Connected, f.Reconnecting].includes(o) ? i || (i = kt(s, e, t)) : [f.Disconnected, f.Failed].includes(o) && i && (Hs(e, o), i(), i = void 0);
    }, b);
  },
  kt = function kt(s, e, t) {
    var r, a;
    var i = Ts(t, e);
    (r = s.getWebrtcInternals()) == null || r.start();
    var o = (a = s.getWebrtcInternals()) == null ? void 0 : a.onStatsChange(function (n) {
      return ms(e, n, t, s);
    });
    return function () {
      i(), o && o();
    };
  },
  Ts = function Ts(s, e) {
    var t, i, o;
    return s.getState(W) ? e.namedSetState(function (r) {
      r.localPeer.id = s.getState(W);
    }, "localpeer-id") : t = s.subscribe(function (r) {
      r && e.namedSetState(function (a) {
        a.localPeer.id = r;
      }, "localpeer-id");
    }, W), s.getState(N) ? e.namedSetState(function (r) {
      r.localPeer.videoTrack = s.getState(N);
    }, "localpeer-videotrack-id") : i = s.subscribe(function (r) {
      r && e.namedSetState(function (a) {
        a.localPeer.videoTrack = r;
      }, "localpeer-videotrack-id");
    }, N), s.getState(C) ? e.namedSetState(function (r) {
      r.localPeer.audioTrack = s.getState(C);
    }, "localpeer-audiotrack-id") : o = s.subscribe(function (r) {
      r && e.namedSetState(function (a) {
        a.localPeer.audioTrack = r;
      }, "localpeer-audiotrack-id");
    }, C), function () {
      t == null || t(), i == null || i(), o == null || o();
    };
  },
  ms = function ms(s, e, t, i) {
    var o = t.getState(h);
    s.namedSetState(function (r) {
      var a = t.getState(W),
        n = {},
        M = Object.keys(o).filter(function (j) {
          return o[j].peerId !== a;
        });
      var _iterator14 = _createForOfIteratorHelper(M),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var j = _step14.value;
          var F = e.getRemoteTrackStats(j);
          F && (n[j] = F);
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      ve(r.remoteTrackStats, n);
      var R = _defineProperty({}, a, e.getLocalPeerStats());
      ve(r.peerStats, R), ft(r.localTrackStats, e.getLocalTrackStats(), i.store.getLocalPeerTracks());
    }, "webrtc-stats");
  },
  Hs = function Hs(s) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "resetState";
    s.namedSetState(function (t) {
      Object.assign(t, oe());
    }, e);
  };
var me = function me(e, t) {
  var _this16 = this;
  _classCallCheck(this, me);
  this.hmsStore = e;
  this.sdk = t;
  this.store = L.createNewHMSStore(Te("HMSStatsStore"), oe), this.getState = this.store.getState, this.subscribe = this.store.subscribe, this.getPublishPeerConnection = function () {
    return new Promise(function (i) {
      var o, r;
      _this16.hmsStore.getState(b) === "Connected" ? i((r = (o = _this16.sdk) == null ? void 0 : o.getWebrtcInternals()) == null ? void 0 : r.getPublishPeerConnection()) : _this16.hmsStore.subscribe(function (a) {
        var n, M;
        a === "Connected" && i((M = (n = _this16.sdk) == null ? void 0 : n.getWebrtcInternals()) == null ? void 0 : M.getPublishPeerConnection());
      }, b);
    });
  }, this.getSubscribePeerConnection = function () {
    return new Promise(function (i) {
      var o, r;
      _this16.hmsStore.getState(b) === "Connected" ? i((r = (o = _this16.sdk) == null ? void 0 : o.getWebrtcInternals()) == null ? void 0 : r.getSubscribePeerConnection()) : _this16.hmsStore.subscribe(function (a) {
        var n, M;
        a === "Connected" && i((M = (n = _this16.sdk) == null ? void 0 : n.getWebrtcInternals()) == null ? void 0 : M.getSubscribePeerConnection());
      }, b);
    });
  }, !!this.sdk && yt(this.sdk, this.store, this.hmsStore);
};
import { createSelector as k } from "reselect";
var fs = function fs(s) {
    return s.localPeer.id;
  },
  hs = function hs(s) {
    return s.localPeer.audioTrack;
  },
  gs = function gs(s) {
    return s.localPeer.videoTrack;
  },
  ys = function ys(s, e) {
    return e;
  },
  Pt = function Pt(s, e) {
    return e;
  },
  ks = function ks(s) {
    return s.remoteTrackStats;
  },
  Rt = function Rt(s) {
    return s.peerStats;
  },
  Le = function Le(s) {
    return s.localTrackStats;
  },
  B = k([Rt, fs], function (s, e) {
    return s[e];
  }),
  Ps = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.subscribe) == null ? void 0 : e.packetsLost;
  }),
  Rs = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.subscribe) == null ? void 0 : e.jitter;
  }),
  Ds = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.publish) == null ? void 0 : e.bitrate;
  }),
  Is = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.subscribe) == null ? void 0 : e.bitrate;
  }),
  vs = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.publish) == null ? void 0 : e.availableOutgoingBitrate;
  }),
  Es = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.subscribe) == null ? void 0 : e.availableIncomingBitrate;
  }),
  bs = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.publish) == null ? void 0 : e.bytesSent;
  }),
  As = k(B, function (s) {
    var e;
    return (e = s == null ? void 0 : s.subscribe) == null ? void 0 : e.bytesReceived;
  }),
  Cs = k([Rt, ys], function (s, e) {
    return e ? s[e] : void 0;
  }),
  Ns = k([ks, Pt], function (s, e) {
    return e ? s[e] : void 0;
  }),
  Oe = k([Le, Pt], function (s, e) {
    return e ? s[e] : void 0;
  }),
  xs = d(Cs),
  Ls = d(Ns),
  Os = k([Le, hs], function (s, e) {
    var t;
    return e ? (t = s[e]) == null ? void 0 : t[0] : void 0;
  }),
  ws = d(k(Oe, function (s) {
    return s == null ? void 0 : s[0];
  })),
  _s = k([Le, gs], function (s, e) {
    var t;
    return e ? (t = s[e]) == null ? void 0 : t[0] : void 0;
  }),
  Us = d(k(Oe, function (s) {
    return s;
  })),
  Ks = function Ks(s) {
    return d(k(Oe, function (e) {
      var t = Object.keys(re).find(function (i) {
        return re[i] === s;
      });
      return s && (e == null ? void 0 : e.find(function (i) {
        return i.rid === t;
      })) || (e == null ? void 0 : e[0]);
    }));
  },
  Vs = {
    localPeerStats: B,
    packetsLost: Ps,
    jitter: Rs,
    publishBitrate: Ds,
    subscribeBitrate: Is,
    availablePublishBitrate: vs,
    availableSubscribeBitrate: Es,
    totalBytesSent: bs,
    totalBytesReceived: As,
    peerStatsByID: xs,
    trackStatsByID: Ls,
    localAudioTrackStatsByID: ws,
    localVideoTrackStatsByID: Us,
    localVideoTrackStatsByLayer: Ks,
    localAudioTrackStats: Os,
    localVideoTrackStats: _s
  };
var L = /*#__PURE__*/function () {
  function L(e, t, i) {
    var _this17 = this;
    _classCallCheck(this, L);
    this.getStats = function () {
      return _this17.stats || (_this17.stats = new me(_this17.store, _this17.sdk)), _this17.stats;
    };
    e ? this.store = e : this.store = L.createNewHMSStore(Te("HMSStore"), ie), i ? this.notifications = i : this.notifications = new Ie(this.store), t ? this.actions = t : (this.sdk = new $s(), this.actions = new Ne(this.store, this.sdk, this.notifications)), this.actions.setFrameworkInfo({
      type: "js",
      sdkVersion: Dt().version
    }), this.initialTriggerOnSubscribe = !1, Gs && (window.__hms = this, window.__beam = new xe(this.store, this.actions, this.notifications));
  }
  _createClass(L, [{
    key: "triggerOnSubscribe",
    value: function triggerOnSubscribe() {
      this.initialTriggerOnSubscribe || (L.makeStoreTriggerOnSubscribe(this.store), this.initialTriggerOnSubscribe = !0);
    }
  }, {
    key: "getStore",
    value: function getStore() {
      return this.store;
    }
  }, {
    key: "getHMSActions",
    value: function getHMSActions() {
      return this.actions;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return this.actions;
    }
  }, {
    key: "getNotifications",
    value: function getNotifications() {
      return {
        onNotification: this.notifications.onNotification
      };
    }
  }], [{
    key: "createNewHMSStore",
    value: function createNewHMSStore(e, t) {
      var i = Fs(function () {
          return t();
        }),
        o = i.setState;
      i.setState = function (n) {
        var M = typeof n == "function" ? qs(n) : n;
        o(M);
      };
      var r = i.getState;
      i.getState = function (n) {
        return n ? n(r()) : r();
      }, L.compareWithShallowCheckInSubscribe(i);
      var a = L.setUpDevtools(i, e);
      return Q(w({}, i), {
        namedSetState: a
      });
    }
  }, {
    key: "makeStoreTriggerOnSubscribe",
    value: function makeStoreTriggerOnSubscribe(e) {
      var t = e.subscribe;
      e.subscribe = function (i, o, r) {
        return i(e.getState(o), void 0), t(i, o, r);
      };
    }
  }, {
    key: "compareWithShallowCheckInSubscribe",
    value: function compareWithShallowCheckInSubscribe(e) {
      var t = e.subscribe;
      e.subscribe = function (i, o, r) {
        return o || (o = function o(a) {
          return a;
        }), r = r || js, t(i, o, r);
      };
    }
  }, {
    key: "setUpDevtools",
    value: function setUpDevtools(e, t) {
      var i;
      try {
        i = window.__REDUX_DEVTOOLS_EXTENSION__ || window.top.__REDUX_DEVTOOLS_EXTENSION__;
      } catch (a) {}
      if (!i) return function (a) {
        e.setState(a);
      };
      var o = i.connect(L.devtoolsOptions(t));
      o.prefix = t ? "".concat(t, " > ") : "";
      var r = e.setState;
      return e.setState = function (a) {
        r(a), o.send("".concat(o.prefix, "setState"), e.getState());
      }, o.subscribe(L.devtoolsSubscribe(o, e, r)), o.send("setUpStore", e.getState()), function (a, n) {
        r(a);
        var M = n || "".concat(o.prefix, "action");
        o.send(M, e.getState());
      };
    }
  }, {
    key: "devtoolsOptions",
    value: function devtoolsOptions(e) {
      return {
        name: e,
        actionsBlacklist: ["audioLevel", "playlistProgress", "connectionQuality"]
      };
    }
  }, {
    key: "devtoolsSubscribe",
    value: function devtoolsSubscribe(e, t, i) {
      return function (o) {
        var r, a, n, M;
        if (o.type === "DISPATCH" && o.state) ["JUMP_TO_ACTION", "JUMP_TO_STATE"].includes(o.payload.type) ? i(JSON.parse(o.state)) : t.setState(JSON.parse(o.state));else if (o.type === "DISPATCH" && ((r = o.payload) == null ? void 0 : r.type) === "COMMIT") e.init(t.getState());else if (o.type === "DISPATCH" && ((a = o.payload) == null ? void 0 : a.type) === "IMPORT_STATE") {
          var R = (n = o.payload.nextLiftedState) == null ? void 0 : n.actionsById;
          (((M = o.payload.nextLiftedState) == null ? void 0 : M.computedStates) || []).forEach(function (_ref2, g) {
            var F = _ref2.state;
            var q = R[g] || "".concat(e.prefix, "setState");
            g === 0 ? e.init(F) : (i(F), e.send(q, t.getState()));
          });
        }
      };
    }
  }]);
  return L;
}();
export { xe as BeamControllerStore, Nt as DeviceType, xt as HMSAudioPluginType, y as HMSLogLevel, Ke as HMSMessageType, P as HMSNotificationSeverity, m as HMSNotificationTypes, p as HMSPlaylistType, L as HMSReactiveStore, f as HMSRoomState, Lt as HMSSimulcastLayer, me as HMSStats, Ot as HMSVideoPluginCanvasContextType, wt as HMSVideoPluginType, oe as createDefaultStatsStore, ie as createDefaultStoreState, _t as parsedUserAgent, Go as selectAppData, Wo as selectAppDataByPath, ot as selectAudioPlaylist, ar as selectAudioPlaylistTrackByPeerID, Jo as selectAudioTrackByID, zt as selectAudioTrackByPeerID, ut as selectAudioTrackVolume, ur as selectAudioVolumeByPeerID, ir as selectAuxiliaryAudioByPeerID, Zo as selectAuxiliaryTracksByPeerID, Ro as selectAvailableRoleNames, Zt as selectBroadcastMessages, Tr as selectBroadcastMessagesUnreadCount, Xo as selectCameraStreamByPeerID, no as selectConnectionQualities, sr as selectConnectionQualityByPeerID, go as selectDegradedTracks, ao as selectDevices, Br as selectDidIJoinWithin, Mo as selectDominantSpeaker, Kt as selectErrors, fe as selectFullAppData, Eo as selectHLSState, Se as selectHMSMessages, We as selectHMSMessagesCount, Vs as selectHMSStats, Cr as selectIsAllowedToPreviewMedia, Ar as selectIsAllowedToPublish, Do as selectIsAllowedToSubscribe, dt as selectIsAudioLocallyMuted, he as selectIsConnectedToRoom, ko as selectIsInPreview, po as selectIsLocalAudioEnabled, Ur as selectIsLocalAudioPluginPresent, ye as selectIsLocalScreenShared, Ge as selectIsLocalVideoDisplayEnabled, ge as selectIsLocalVideoEnabled, _r as selectIsLocalVideoPluginPresent, lr as selectIsLocallyMutedByPeerID, cr as selectIsPeerAudioEnabled, Sr as selectIsPeerVideoEnabled, wr as selectIsRoleAllowedToPublish, dr as selectIsScreenShareLocallyMutedByPeerID, To as selectIsSomeoneScreenSharing, C as selectLocalAudioTrackID, Fe as selectLocalMediaSettings, E as selectLocalPeer, W as selectLocalPeerID, So as selectLocalPeerName, le as selectLocalPeerRole, lo as selectLocalPeerRoleName, $e as selectLocalTrackIDs, N as selectLocalVideoTrackID, je as selectMessageIDsInOrder, mr as selectMessagesByPeerID, Hr as selectMessagesByRole, qe as selectMessagesMap, hr as selectMessagesUnreadCountByPeerID, fr as selectMessagesUnreadCountByRole, tr as selectPeerAudioByID, Kr as selectPeerByCondition, x as selectPeerByID, co as selectPeerCount, kr as selectPeerMetadata, Pr as selectPeerName, Qo as selectPeerNameByID, jt as selectPeerScreenSharing, mo as selectPeerSharingAudio, ho as selectPeerSharingAudioPlaylist, fo as selectPeerSharingVideoPlaylist, G as selectPeers, Vr as selectPeersByCondition, gr as selectPeersByRole, yr as selectPeersByRoles, v as selectPeersMap, Ho as selectPeersScreenSharing, Er as selectPeersWithAudioStatus, Je as selectPermissions, Qe as selectPreviewRole, Ft as selectPreviewRoleName, vo as selectRTMPState, oo as selectRecentError, Io as selectRecordingState, uo as selectRemotePeers, is as selectRoleByRoleName, br as selectRoleChangeRequest, _ as selectRolesMap, D as selectRoom, ro as selectRoomID, Ao as selectRoomStartTime, Po as selectRoomStarted, b as selectRoomState, Yo as selectScreenAudioTrackByID, lt as selectScreenShareAudioByPeerID, nr as selectScreenShareByPeerID, St as selectScreenSharesByPeerId, zo as selectScreenVideoTrackByID, Mr as selectScreenshareAudioVolumeByPeerID, bo as selectSessionId, Co as selectSessionMetadata, pr as selectSimulcastLayerByTrack, Vt as selectSpeakers, er as selectTrackAudioByID, de as selectTrackByID, h as selectTracksMap, yo as selectUnreadHMSMessagesCount, rt as selectVideoPlaylist, rr as selectVideoPlaylistAudioTrackByPeerID, or as selectVideoPlaylistVideoTrackByPeerID, nt as selectVideoTrackByID, Yt as selectVideoTrackByPeerID, re as simulcastMapping };